import { openBlock as h, createElementBlock as O, createElementVNode as ae, reactive as Mt, computed as F, unref as u, ref as L, watch as tt, toRef as $t, onMounted as He, nextTick as dt, defineComponent as We, renderSlot as K, createCommentVNode as S, normalizeClass as ye, withKeys as ue, createBlock as fe, withModifiers as Ze, normalizeStyle as Qe, normalizeProps as Pe, mergeProps as Te, Fragment as ce, createTextVNode as ze, toDisplayString as Ce, renderList as De, createVNode as et, Transition as gt, withCtx as oe, onBeforeUpdate as Jn, onUnmounted as dn, withDirectives as _t, vShow as Nt, createSlots as Ve, isRef as ot, guardReactiveProps as Le, resolveDynamicComponent as Yn, useSlots as cn, getCurrentScope as Qn, onScopeDispose as ea, Teleport as ta } from "vue";
import { isBefore as fn, isEqual as Vn, isAfter as vn, set as Se, setHours as En, setMinutes as Fn, setSeconds as Ln, setMilliseconds as mn, parse as on, isValid as Rt, isDate as na, format as wt, getMonth as pe, getDay as aa, getYear as ke, getHours as je, getMinutes as Ge, getSeconds as yt, parseISO as ra, startOfWeek as pn, endOfWeek as la, setMonth as Ot, setYear as ut, addDays as mt, add as Un, addMonths as st, subMonths as bt, getWeek as oa, getISOWeek as sa, differenceInCalendarDays as ia, eachDayOfInterval as kn, addYears as ua, subYears as da, sub as ca } from "date-fns";
function Lt() {
  return h(), O(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ae("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      ae("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      ae("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      ae("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
function fa() {
  return h(), O(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ae("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      ae("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
function wn() {
  return h(), O(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ae("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
function bn() {
  return h(), O(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ae("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
function Hn() {
  return h(), O(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ae("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      ae("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
function Wn() {
  return h(), O(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ae("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
function zn() {
  return h(), O(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ae("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
const Dn = (e, n, a, t, s) => {
  const f = on(e, n.slice(0, e.length), /* @__PURE__ */ new Date());
  return Rt(f) && na(f) ? t || s ? f : Se(f, {
    hours: +a.hours,
    minutes: +(a == null ? void 0 : a.minutes),
    seconds: +(a == null ? void 0 : a.seconds),
    milliseconds: 0
  }) : null;
}, va = (e, n, a, t, s) => {
  const f = Array.isArray(a) ? a[0] : a;
  if (typeof n == "string")
    return Dn(e, n, f, t, s);
  if (Array.isArray(n)) {
    let y = null;
    for (const _ of n)
      if (y = Dn(e, _, f, t, s), y)
        break;
    return y;
  }
  return typeof n == "function" ? n(e) : null;
}, $ = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), ma = (e, n) => {
  if (n) {
    const t = (e.getMonth() + 1).toString().padStart(2, "0"), s = e.getDate().toString().padStart(2, "0"), f = e.getHours().toString().padStart(2, "0"), y = e.getMinutes().toString().padStart(2, "0");
    return `${e.getFullYear()}-${t}-${s}T${f}:${y}:00.000Z`;
  }
  const a = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(a).toISOString();
}, Ue = (e) => {
  let n = $(JSON.parse(JSON.stringify(e)));
  return n = En(n, 0), n = Fn(n, 0), n = Ln(n, 0), n = mn(n, 0), n;
}, Fe = (e, n, a, t) => {
  let s = e ? $(e) : $();
  return (n || n === 0) && (s = En(s, +n)), (a || a === 0) && (s = Fn(s, +a)), (t || t === 0) && (s = Ln(s, +t)), mn(s, 0);
}, _e = (e, n) => !e || !n ? !1 : fn(Ue(e), Ue(n)), ve = (e, n) => !e || !n ? !1 : Vn(Ue(e), Ue(n)), Be = (e, n) => !e || !n ? !1 : vn(Ue(e), Ue(n)), xn = (e, n, a) => e && e[0] && e[1] ? Be(a, e[0]) && _e(a, e[1]) : e && e[0] && n ? Be(a, e[0]) && _e(a, n) || _e(a, e[0]) && Be(a, n) : !1, pt = (e) => {
  const n = Se(new Date(e), { date: 1 });
  return Ue(n);
}, kt = Mt({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), Kn = () => {
  const e = (t) => {
    kt.menuFocused = t;
  }, n = (t) => {
    kt.shiftKeyInMenu !== t && (kt.shiftKeyInMenu = t);
  };
  return {
    control: F(() => ({ shiftKeyInMenu: kt.shiftKeyInMenu, menuFocused: kt.menuFocused })),
    setMenuFocused: e,
    setShiftKey: n
  };
};
function yn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Bt = {}, ya = {
  get exports() {
    return Bt;
  },
  set exports(e) {
    Bt = e;
  }
};
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = a;
  function a(t) {
    if (t === null || t === !0 || t === !1)
      return NaN;
    var s = Number(t);
    return isNaN(s) ? s : s < 0 ? Math.ceil(s) : Math.floor(s);
  }
  e.exports = n.default;
})(ya, Bt);
const ga = /* @__PURE__ */ yn(Bt);
var Yt = {}, ha = {
  get exports() {
    return Yt;
  },
  set exports(e) {
    Yt = e;
  }
};
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = a;
  function a(t) {
    var s = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
    return s.setUTCFullYear(t.getFullYear()), t.getTime() - s.getTime();
  }
  e.exports = n.default;
})(ha, Yt);
const $n = /* @__PURE__ */ yn(Yt);
function pa(e, n) {
  var a = Da(n);
  return a.formatToParts ? wa(a, e) : ba(a, e);
}
var ka = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function wa(e, n) {
  try {
    for (var a = e.formatToParts(n), t = [], s = 0; s < a.length; s++) {
      var f = ka[a[s].type];
      f >= 0 && (t[f] = parseInt(a[s].value, 10));
    }
    return t;
  } catch (y) {
    if (y instanceof RangeError)
      return [NaN];
    throw y;
  }
}
function ba(e, n) {
  var a = e.format(n).replace(/\u200E/g, ""), t = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(a);
  return [t[3], t[1], t[2], t[4], t[5], t[6]];
}
var Xt = {};
function Da(e) {
  if (!Xt[e]) {
    var n = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), a = n === "06/25/2014, 00:00:00" || n === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Xt[e] = a ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Xt[e];
}
function gn(e, n, a, t, s, f, y) {
  var _ = /* @__PURE__ */ new Date(0);
  return _.setUTCFullYear(e, n, a), _.setUTCHours(t, s, f, y), _;
}
var Mn = 36e5, $a = 6e4, qt = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function hn(e, n, a) {
  var t, s;
  if (!e || (t = qt.timezoneZ.exec(e), t))
    return 0;
  var f;
  if (t = qt.timezoneHH.exec(e), t)
    return f = parseInt(t[1], 10), Tn(f) ? -(f * Mn) : NaN;
  if (t = qt.timezoneHHMM.exec(e), t) {
    f = parseInt(t[1], 10);
    var y = parseInt(t[2], 10);
    return Tn(f, y) ? (s = Math.abs(f) * Mn + y * $a, f > 0 ? -s : s) : NaN;
  }
  if (Aa(e)) {
    n = new Date(n || Date.now());
    var _ = a ? n : Ma(n), E = sn(_, e), T = a ? E : Ta(n, E, e);
    return -T;
  }
  return NaN;
}
function Ma(e) {
  return gn(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function sn(e, n) {
  var a = pa(e, n), t = gn(
    a[0],
    a[1] - 1,
    a[2],
    a[3] % 24,
    a[4],
    a[5],
    0
  ).getTime(), s = e.getTime(), f = s % 1e3;
  return s -= f >= 0 ? f : 1e3 + f, t - s;
}
function Ta(e, n, a) {
  var t = e.getTime(), s = t - n, f = sn(new Date(s), a);
  if (n === f)
    return n;
  s -= f - n;
  var y = sn(new Date(s), a);
  return f === y ? f : Math.max(f, y);
}
function Tn(e, n) {
  return -23 <= e && e <= 23 && (n == null || 0 <= n && n <= 59);
}
var An = {};
function Aa(e) {
  if (An[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), An[e] = !0, !0;
  } catch {
    return !1;
  }
}
var Sa = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
const jn = Sa;
var Jt = 36e5, Sn = 6e4, Ca = 2, Ie = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: jn
};
function un(e, n) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var a = n || {}, t = a.additionalDigits == null ? Ca : ga(a.additionalDigits);
  if (t !== 2 && t !== 1 && t !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var s = Pa(e), f = _a(s.date, t), y = f.year, _ = f.restDateString, E = Na(_, y);
  if (isNaN(E))
    return /* @__PURE__ */ new Date(NaN);
  if (E) {
    var T = E.getTime(), U = 0, A;
    if (s.time && (U = Ra(s.time), isNaN(U)))
      return /* @__PURE__ */ new Date(NaN);
    if (s.timeZone || a.timeZone) {
      if (A = hn(s.timeZone || a.timeZone, new Date(T + U)), isNaN(A))
        return /* @__PURE__ */ new Date(NaN);
    } else
      A = $n(new Date(T + U)), A = $n(new Date(T + U + A));
    return new Date(T + U + A);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function Pa(e) {
  var n = {}, a = Ie.dateTimePattern.exec(e), t;
  if (a ? (n.date = a[1], t = a[3]) : (a = Ie.datePattern.exec(e), a ? (n.date = a[1], t = a[2]) : (n.date = null, t = e)), t) {
    var s = Ie.timeZone.exec(t);
    s ? (n.time = t.replace(s[1], ""), n.timeZone = s[1].trim()) : n.time = t;
  }
  return n;
}
function _a(e, n) {
  var a = Ie.YYY[n], t = Ie.YYYYY[n], s;
  if (s = Ie.YYYY.exec(e) || t.exec(e), s) {
    var f = s[1];
    return {
      year: parseInt(f, 10),
      restDateString: e.slice(f.length)
    };
  }
  if (s = Ie.YY.exec(e) || a.exec(e), s) {
    var y = s[1];
    return {
      year: parseInt(y, 10) * 100,
      restDateString: e.slice(y.length)
    };
  }
  return {
    year: null
  };
}
function Na(e, n) {
  if (n === null)
    return null;
  var a, t, s, f;
  if (e.length === 0)
    return t = /* @__PURE__ */ new Date(0), t.setUTCFullYear(n), t;
  if (a = Ie.MM.exec(e), a)
    return t = /* @__PURE__ */ new Date(0), s = parseInt(a[1], 10) - 1, Pn(n, s) ? (t.setUTCFullYear(n, s), t) : /* @__PURE__ */ new Date(NaN);
  if (a = Ie.DDD.exec(e), a) {
    t = /* @__PURE__ */ new Date(0);
    var y = parseInt(a[1], 10);
    return Ba(n, y) ? (t.setUTCFullYear(n, 0, y), t) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = Ie.MMDD.exec(e), a) {
    t = /* @__PURE__ */ new Date(0), s = parseInt(a[1], 10) - 1;
    var _ = parseInt(a[2], 10);
    return Pn(n, s, _) ? (t.setUTCFullYear(n, s, _), t) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = Ie.Www.exec(e), a)
    return f = parseInt(a[1], 10) - 1, _n(n, f) ? Cn(n, f) : /* @__PURE__ */ new Date(NaN);
  if (a = Ie.WwwD.exec(e), a) {
    f = parseInt(a[1], 10) - 1;
    var E = parseInt(a[2], 10) - 1;
    return _n(n, f, E) ? Cn(n, f, E) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function Ra(e) {
  var n, a, t;
  if (n = Ie.HH.exec(e), n)
    return a = parseFloat(n[1].replace(",", ".")), Qt(a) ? a % 24 * Jt : NaN;
  if (n = Ie.HHMM.exec(e), n)
    return a = parseInt(n[1], 10), t = parseFloat(n[2].replace(",", ".")), Qt(a, t) ? a % 24 * Jt + t * Sn : NaN;
  if (n = Ie.HHMMSS.exec(e), n) {
    a = parseInt(n[1], 10), t = parseInt(n[2], 10);
    var s = parseFloat(n[3].replace(",", "."));
    return Qt(a, t, s) ? a % 24 * Jt + t * Sn + s * 1e3 : NaN;
  }
  return null;
}
function Cn(e, n, a) {
  n = n || 0, a = a || 0;
  var t = /* @__PURE__ */ new Date(0);
  t.setUTCFullYear(e, 0, 4);
  var s = t.getUTCDay() || 7, f = n * 7 + a + 1 - s;
  return t.setUTCDate(t.getUTCDate() + f), t;
}
var Oa = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Ia = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Gn(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Pn(e, n, a) {
  if (n < 0 || n > 11)
    return !1;
  if (a != null) {
    if (a < 1)
      return !1;
    var t = Gn(e);
    if (t && a > Ia[n] || !t && a > Oa[n])
      return !1;
  }
  return !0;
}
function Ba(e, n) {
  if (n < 1)
    return !1;
  var a = Gn(e);
  return !(a && n > 366 || !a && n > 365);
}
function _n(e, n, a) {
  return !(n < 0 || n > 52 || a != null && (a < 0 || a > 6));
}
function Qt(e, n, a) {
  return !(e != null && (e < 0 || e >= 25) || n != null && (n < 0 || n >= 60) || a != null && (a < 0 || a >= 60));
}
var Vt = {}, Ya = {
  get exports() {
    return Vt;
  },
  set exports(e) {
    Vt = e;
  }
}, Et = {}, Va = {
  get exports() {
    return Et;
  },
  set exports(e) {
    Et = e;
  }
};
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = a;
  function a(t, s) {
    if (t == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var f in s)
      Object.prototype.hasOwnProperty.call(s, f) && (t[f] = s[f]);
    return t;
  }
  e.exports = n.default;
})(Va, Et);
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = s;
  var a = t(Et);
  function t(f) {
    return f && f.__esModule ? f : { default: f };
  }
  function s(f) {
    return (0, a.default)({}, f);
  }
  e.exports = n.default;
})(Ya, Vt);
const Ea = /* @__PURE__ */ yn(Vt);
function Fa(e, n, a) {
  var t = un(e, a), s = hn(n, t, !0), f = new Date(t.getTime() - s), y = /* @__PURE__ */ new Date(0);
  return y.setFullYear(f.getUTCFullYear(), f.getUTCMonth(), f.getUTCDate()), y.setHours(f.getUTCHours(), f.getUTCMinutes(), f.getUTCSeconds(), f.getUTCMilliseconds()), y;
}
function La(e, n, a) {
  if (typeof e == "string" && !e.match(jn)) {
    var t = Ea(a);
    return t.timeZone = n, un(e, t);
  }
  var s = un(e, a), f = gn(
    s.getFullYear(),
    s.getMonth(),
    s.getDate(),
    s.getHours(),
    s.getMinutes(),
    s.getSeconds(),
    s.getMilliseconds()
  ).getTime(), y = hn(n, new Date(f));
  return new Date(f + y);
}
const Ua = (e, n = 3) => {
  const a = [];
  for (let t = 0; t < e.length; t += n)
    a.push([e[t], e[t + 1], e[t + 2]]);
  return a;
}, Ha = (e, n) => {
  const a = [1, 2, 3, 4, 5, 6, 7].map((f) => new Intl.DateTimeFormat(e, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${f}T00:00:00+00:00`)).slice(0, 2)), t = a.slice(0, n), s = a.slice(n + 1, a.length);
  return [a[n]].concat(...s).concat(...t);
}, Wa = (e, n) => {
  const a = [];
  for (let t = +e[0]; t <= +e[1]; t++)
    a.push({ value: +t, text: `${t}` });
  return n ? a.reverse() : a;
}, za = (e, n) => {
  const a = new Intl.DateTimeFormat(e, { month: n, timeZone: "UTC" });
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((s) => {
    const f = s < 10 ? `0${s}` : s;
    return /* @__PURE__ */ new Date(`2017-${f}-01T00:00:00+00:00`);
  }).map((s, f) => ({
    text: a.format(s),
    value: f
  }));
}, xa = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], $e = (e) => {
  const n = u(e);
  return n != null && n.$el ? n == null ? void 0 : n.$el : n;
}, Ka = (e) => Object.assign({ type: "dot" }, e), Zn = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, Ft = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, Me = (e) => e, Nn = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, Rn = (e) => Object.assign(
  {
    menuAppear: "dp-menu-appear",
    open: "dp-slide-down",
    close: "dp-slide-up",
    next: "calendar-next",
    previous: "calendar-prev",
    vNext: "dp-slide-up",
    vPrevious: "dp-slide-down"
  },
  e
), ja = (e) => Object.assign(
  {
    toggleOverlay: "Toggle overlay",
    menu: "Datepicker menu",
    input: "Datepicker input",
    calendarWrap: "Calendar wrapper",
    calendarDays: "Calendar days",
    openTimePicker: "Open time picker",
    closeTimePicker: "Close time Picker",
    incrementValue: (n) => `Increment ${n}`,
    decrementValue: (n) => `Decrement ${n}`,
    openTpOverlay: (n) => `Open ${n} overlay`,
    amPmButton: "Switch AM/PM mode",
    openYearsOverlay: "Open years overlay",
    openMonthsOverlay: "Open months overlay",
    nextMonth: "Next month",
    prevMonth: "Previous month",
    day: () => ""
  },
  e
), Ga = (e) => e === null ? 0 : typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2, Za = (e, n, a) => e || (typeof a == "string" ? a : n), Xa = (e) => typeof e == "boolean" ? e ? Rn({}) : !1 : Rn(e), qa = () => ({
  enterSubmit: !0,
  tabSubmit: !0,
  openMenu: !0,
  rangeSeparator: " - "
}), Ja = (e) => Object.assign({ months: [], years: [], times: { hours: [], minutes: [], seconds: [] } }, e), Ee = (e) => {
  const n = () => {
    if (e.partialRange)
      return null;
    throw new Error(Ft.prop("partial-range"));
  }, a = F(() => ({
    ariaLabels: ja(e.ariaLabels),
    textInputOptions: Object.assign(qa(), e.textInputOptions),
    multiCalendars: Ga(e.multiCalendars),
    previewFormat: Za(e.previewFormat, e.format, f()),
    filters: Ja(e.filters),
    transitions: Xa(e.transitions),
    startTime: c()
  })), t = (o) => {
    if (e.range)
      return o();
    throw new Error(Ft.prop("range"));
  }, s = () => {
    const o = e.enableSeconds ? ":ss" : "";
    return e.is24 ? `HH:mm${o}` : `hh:mm${o} aa`;
  }, f = () => e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? s() : e.weekPicker ? "MM/dd/yyyy" : e.yearPicker ? "yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${s()}` : "MM/dd/yyyy", y = (o, g) => {
    if (typeof e.format == "function")
      return e.format(o);
    const r = g || f(), k = e.formatLocale ? { locale: e.formatLocale } : void 0;
    return Array.isArray(o) ? `${wt(o[0], r, k)} ${e.modelAuto && !o[1] ? "" : a.value.textInputOptions.rangeSeparator || "-"} ${o[1] ? wt(o[1], r, k) : ""}` : wt(o, r, k);
  }, _ = (o) => e.timezone ? Fa(o, e.timezone) : o, E = (o) => e.timezone ? La(o, e.timezone) : o, T = F(() => (o) => {
    var g;
    return (g = e.hideNavigation) == null ? void 0 : g.includes(o);
  }), U = (o) => {
    const g = e.maxDate ? Be(_(o), _($(e.maxDate))) : !1, r = e.minDate ? _e(_(o), _($(e.minDate))) : !1, k = B(o, e.disabledDates), R = a.value.filters.months.map((se) => +se).includes(pe(o)), m = e.disabledWeekDays.length ? e.disabledWeekDays.some((se) => +se === aa(o)) : !1, b = e.allowedDates.length ? !e.allowedDates.some((se) => ve(_($(se)), _(o))) : !1, v = ke(o), W = v < +e.yearRange[0] || v > +e.yearRange[1];
    return !(g || r || k || R || W || m || b);
  }, A = (o) => {
    const g = {
      hours: je($()),
      minutes: Ge($()),
      seconds: e.enableSeconds ? yt($()) : 0
    };
    return Object.assign(g, o);
  }, c = () => e.range ? e.startTime && Array.isArray(e.startTime) ? [A(e.startTime[0]), A(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? A(e.startTime) : null, M = (o) => !U(o), te = (o) => Array.isArray(o) ? Rt(o[0]) && (o[1] ? Rt(o[1]) : !0) : o ? Rt(o) : !1, H = (o) => o instanceof Date ? o : ra(o), z = (o) => {
    const g = pn(_(o), { weekStartsOn: +e.weekStart }), r = la(_(o), { weekStartsOn: +e.weekStart });
    return [g, r];
  }, B = (o, g) => Array.isArray(g) ? g.some((r) => ve(_($(r)), _(o))) : g($(JSON.parse(JSON.stringify(o)))), w = (o, g, r) => {
    let k = o ? $(o) : $();
    return (g || g === 0) && (k = Ot(k, g)), r && (k = ut(k, r)), k;
  }, J = (o) => Se($(), { hours: je(o), minutes: Ge(o), seconds: yt(o) }), ee = (o) => Se($(), {
    hours: +o.hours || 0,
    minutes: +o.minutes || 0,
    seconds: +o.seconds || 0
  }), x = (o, g, r, k) => {
    if (!o)
      return !0;
    if (k) {
      const Y = r === "max" ? fn(o, g) : vn(o, g), R = { seconds: 0, milliseconds: 0 };
      return Y || Vn(Se(o, R), Se(g, R));
    }
    return r === "max" ? o.getTime() <= g.getTime() : o.getTime() >= g.getTime();
  }, le = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, de = (o) => Array.isArray(o) ? [o[0] ? J(o[0]) : null, o[1] ? J(o[1]) : null] : J(o), C = (o) => {
    const g = e.maxTime ? ee(e.maxTime) : $(e.maxDate);
    return Array.isArray(o) ? x(o[0], g, "max", !!e.maxDate) && x(o[1], g, "max", !!e.maxDate) : x(o, g, "max", !!e.maxDate);
  }, N = (o, g) => {
    const r = e.minTime ? ee(e.minTime) : $(e.minDate);
    return Array.isArray(o) ? x(o[0], r, "min", !!e.minDate) && x(o[1], r, "min", !!e.minDate) && g : x(o, r, "min", !!e.minDate) && g;
  }, G = (o) => {
    let g = !0;
    if (!o || le())
      return !0;
    const r = !e.minDate && !e.maxDate ? de(o) : o;
    return (e.maxTime || e.maxDate) && (g = C(Me(r))), (e.minTime || e.minDate) && (g = N(Me(r), g)), g;
  }, P = (o, g) => {
    const r = $(JSON.parse(JSON.stringify(o))), k = [];
    for (let Y = 0; Y < 7; Y++) {
      const R = mt(r, Y), m = pe(R) !== g;
      k.push({
        text: e.hideOffsetDates && m ? "" : R.getDate(),
        value: R,
        current: !m,
        classData: {}
      });
    }
    return k;
  }, Z = (o, g) => {
    const r = [], k = $(_(new Date(g, o))), Y = $(_(new Date(g, o + 1, 0))), R = pn(k, { weekStartsOn: e.weekStart }), m = (b) => {
      const v = P(b, o);
      if (r.push({ days: v }), !r[r.length - 1].days.some(
        (W) => ve(Ue(W.value), Ue(Y))
      )) {
        const W = mt(b, 7);
        m(W);
      }
    };
    if (m(R), e.sixWeeks && r.length < 6) {
      const b = 6 - r.length;
      for (let v = 1; v <= b; v++) {
        const W = r[r.length - 1], se = W.days[W.days.length - 1], Ne = P(mt(se.value, 1), pe(k));
        r.push({ days: Ne });
      }
    }
    return r;
  }, p = (o, g, r) => [Se($(o), { date: 1 }), Se($(), { month: g, year: r, date: 1 })], q = (o, g) => _e(...p(e.minDate, o, g)) || ve(...p(e.minDate, o, g)), j = (o, g) => Be(...p(e.maxDate, o, g)) || ve(...p(e.maxDate, o, g)), I = (o, g, r) => {
    let k = !1;
    return e.maxDate && r && j(o, g) && (k = !0), e.minDate && !r && q(o, g) && (k = !0), k;
  };
  return {
    checkPartialRangeValue: n,
    checkRangeEnabled: t,
    getZonedDate: _,
    getZonedToUtc: E,
    formatDate: y,
    getDefaultPattern: f,
    validateDate: U,
    getDefaultStartTime: c,
    isDisabled: M,
    isValidDate: te,
    sanitizeDate: H,
    getWeekFromDate: z,
    matchDate: B,
    setDateMonthOrYear: w,
    isValidTime: G,
    getCalendarDays: Z,
    validateMonthYearInRange: (o, g, r, k) => {
      let Y = !1;
      return k ? e.minDate && e.maxDate ? Y = I(o, g, r) : (e.minDate && q(o, g) || e.maxDate && j(o, g)) && (Y = !0) : Y = !0, Y;
    },
    validateMaxDate: j,
    validateMinDate: q,
    assignDefaultTime: A,
    defaults: a,
    hideNavigationButtons: T
  };
}, he = Mt({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), en = L(null), Pt = L(!1), tn = L(!1), nn = L(!1), an = L(!1), Oe = L(0), Ae = L(0), nt = () => {
  const e = F(() => Pt.value ? [...he.selectionGrid, he.actionRow].filter((B) => B.length) : tn.value ? [
    ...he.timePicker[0],
    ...he.timePicker[1],
    an.value ? [] : [en.value],
    he.actionRow
  ].filter((B) => B.length) : nn.value ? [...he.monthPicker, he.actionRow] : [he.monthYear, ...he.calendar, he.time, he.actionRow].filter((B) => B.length)), n = (B) => {
    Oe.value = B ? Oe.value + 1 : Oe.value - 1;
    let w = null;
    e.value[Ae.value] && (w = e.value[Ae.value][Oe.value]), w || (Oe.value = B ? Oe.value - 1 : Oe.value + 1);
  }, a = (B) => {
    if (Ae.value === 0 && !B || Ae.value === e.value.length && B)
      return;
    Ae.value = B ? Ae.value + 1 : Ae.value - 1, e.value[Ae.value] ? e.value[Ae.value] && !e.value[Ae.value][Oe.value] && Oe.value !== 0 && (Oe.value = e.value[Ae.value].length - 1) : Ae.value = B ? Ae.value - 1 : Ae.value + 1;
  }, t = (B) => {
    let w = null;
    e.value[Ae.value] && (w = e.value[Ae.value][Oe.value]), w ? w.focus({ preventScroll: !Pt.value }) : Oe.value = B ? Oe.value - 1 : Oe.value + 1;
  }, s = () => {
    n(!0), t(!0);
  }, f = () => {
    n(!1), t(!1);
  }, y = () => {
    a(!1), t(!0);
  }, _ = () => {
    a(!0), t(!0);
  }, E = (B, w) => {
    he[w] = B;
  }, T = (B, w) => {
    he[w] = B;
  }, U = () => {
    Oe.value = 0, Ae.value = 0;
  };
  return {
    buildMatrix: E,
    buildMultiLevelMatrix: T,
    setTimePickerBackRef: (B) => {
      en.value = B;
    },
    setSelectionGrid: (B) => {
      Pt.value = B, U(), B || (he.selectionGrid = []);
    },
    setTimePicker: (B, w = !1) => {
      tn.value = B, an.value = w, U(), B || (he.timePicker[0] = [], he.timePicker[1] = []);
    },
    setTimePickerElements: (B, w = 0) => {
      he.timePicker[w] = B;
    },
    arrowRight: s,
    arrowLeft: f,
    arrowUp: y,
    arrowDown: _,
    clearArrowNav: () => {
      he.monthYear = [], he.calendar = [], he.time = [], he.actionRow = [], he.selectionGrid = [], he.timePicker[0] = [], he.timePicker[1] = [], Pt.value = !1, tn.value = !1, an.value = !1, nn.value = !1, U(), en.value = null;
    },
    setMonthPicker: (B) => {
      nn.value = B, U();
    },
    refSets: he
    // exposed for testing
  };
}, On = (e) => Array.isArray(e), lt = (e) => Array.isArray(e), In = (e) => Array.isArray(e) && e.length === 2, Qa = (e, n, a, t, s) => {
  const {
    getDefaultStartTime: f,
    isDisabled: y,
    sanitizeDate: _,
    getWeekFromDate: E,
    setDateMonthOrYear: T,
    validateMonthYearInRange: U,
    defaults: A
  } = Ee(e), c = F({
    get: () => e.internalModelValue,
    set: (i) => {
      !e.readonly && !e.disabled && n("update:internal-model-value", i);
    }
  }), M = L([]);
  tt(c, () => {
    le();
  });
  const te = $t(e, "multiCalendars");
  tt(te, () => {
    Je(0);
  });
  const H = L([{ month: pe($()), year: ke($()) }]), z = Mt({
    hours: e.range ? [je($()), je($())] : je($()),
    minutes: e.range ? [Ge($()), Ge($())] : Ge($()),
    seconds: e.range ? [0, 0] : 0
  }), B = F(
    () => (i) => H.value[i] ? H.value[i].month : 0
  ), w = F(
    () => (i) => H.value[i] ? H.value[i].year : 0
  ), J = F(() => e.flow && e.flow.length && !e.partialFlow ? s.value === e.flow.length : !0), ee = (i, D, Q) => {
    var d, V;
    H.value[i] || (H.value[i] = { month: 0, year: 0 }), H.value[i].month = D === null ? (d = H.value[i]) == null ? void 0 : d.month : D, H.value[i].year = Q === null ? (V = H.value[i]) == null ? void 0 : V.year : Q;
  }, x = (i, D) => {
    z[i] = D;
  };
  He(() => {
    c.value || (e.startDate && (ee(0, pe($(e.startDate)), ke($(e.startDate))), A.value.multiCalendars && Je(0)), A.value.startTime && I()), le(!0);
  });
  const le = (i = !1) => {
    if (c.value)
      return Array.isArray(c.value) ? (M.value = c.value, P(i)) : C(c.value);
    if (e.timePicker)
      return Z();
    if (e.monthPicker && !e.range)
      return p();
    if (e.yearPicker && !e.range)
      return q();
    if (A.value.multiCalendars && i && !e.startDate)
      return de($(), i);
  }, de = (i, D = !1) => {
    if ((!A.value.multiCalendars || !e.multiStatic || D) && ee(0, pe(i), ke(i)), A.value.multiCalendars)
      for (let Q = 1; Q < A.value.multiCalendars; Q++) {
        const d = Se($(), { month: B.value(Q - 1), year: w.value(Q - 1) }), V = Un(d, { months: 1 });
        H.value[Q] = { month: pe(V), year: ke(V) };
      }
  }, C = (i) => {
    de(i), x("hours", je(i)), x("minutes", Ge(i)), x("seconds", yt(i));
  }, N = (i, D) => {
    de(i[0], D);
    const Q = (d, V) => [
      d(i[0]),
      i[1] ? d(i[1]) : z[V][1]
    ];
    x("hours", Q(je, "hours")), x("minutes", Q(Ge, "minutes")), x("seconds", Q(yt, "seconds"));
  }, G = (i, D) => {
    if ((e.range || e.weekPicker) && !e.multiDates)
      return N(i, D);
    if (e.multiDates) {
      const Q = i[i.length - 1];
      return C(Q);
    }
  }, P = (i) => {
    const D = c.value;
    G(D, i), A.value.multiCalendars && e.multiCalendarsSolo && o();
  }, Z = () => {
    if (I(), !e.range)
      c.value = Fe($(), z.hours, z.minutes, j());
    else {
      const i = z.hours, D = z.minutes;
      c.value = [
        Fe($(), i[0], D[0], j()),
        Fe($(), i[1], D[1], j(!1))
      ];
    }
  }, p = () => {
    e.multiDates ? c.value = [T($(), B.value(0), w.value(0))] : c.value = T($(), B.value(0), w.value(0));
  }, q = () => {
    c.value = $();
  }, j = (i = !0) => e.enableSeconds ? Array.isArray(z.seconds) ? i ? z.seconds[0] : z.seconds[1] : z.seconds : 0, I = () => {
    const i = f();
    if (i) {
      const D = Array.isArray(i), Q = D ? [+i[0].hours, +i[1].hours] : +i.hours, d = D ? [+i[0].minutes, +i[1].minutes] : +i.minutes, V = D ? [+i[0].seconds, +i[1].seconds] : +i.seconds;
      x("hours", Q), x("minutes", d), e.enableSeconds && x("seconds", V);
    }
  }, l = () => Array.isArray(c.value) && c.value.length ? c.value[c.value.length - 1] : null, o = () => {
    if (Array.isArray(c.value) && c.value.length === 2) {
      const i = $(
        $(c.value[1] ? c.value[1] : st(c.value[0], 1))
      ), [D, Q] = [pe(c.value[0]), ke(c.value[0])], [d, V] = [pe(c.value[1]), ke(c.value[1])];
      (D !== d || D === d && Q !== V) && e.multiCalendarsSolo && ee(1, pe(i), ke(i));
    }
  }, g = (i) => {
    const D = st(i, 1);
    return { month: pe(D), year: ke(D) };
  }, r = (i) => {
    const D = pe($(i)), Q = ke($(i));
    if (ee(0, D, Q), A.value.multiCalendars > 0)
      for (let d = 1; d < A.value.multiCalendars; d++) {
        const V = g(
          Se($(i), { year: B.value(d - 1), month: w.value(d - 1) })
        );
        ee(d, V.month, V.year);
      }
  }, k = (i) => {
    if (c.value && Array.isArray(c.value))
      if (c.value.some((D) => ve(i, D))) {
        const D = c.value.filter((Q) => !ve(Q, i));
        c.value = D.length ? D : null;
      } else
        (e.multiDatesLimit && +e.multiDatesLimit > c.value.length || !e.multiDatesLimit) && c.value.push(i);
    else
      c.value = [i];
  }, Y = (i, D) => {
    const Q = Be(i, D) ? D : i, d = Be(D, i) ? D : i;
    return kn({ start: Q, end: d });
  }, R = (i, D = 0) => {
    if (Array.isArray(c.value) && c.value[D]) {
      const Q = ia(i, c.value[D]), d = Y(c.value[D], i), V = d.length === 1 ? 0 : d.filter((be) => y(be)).length, we = Math.abs(Q) - V;
      if (e.minRange && e.maxRange)
        return we >= +e.minRange && we <= +e.maxRange;
      if (e.minRange)
        return we >= +e.minRange;
      if (e.maxRange)
        return we <= +e.maxRange;
    }
    return !0;
  }, m = (i) => Array.isArray(c.value) && c.value.length === 2 ? e.fixedStart && (Be(i, c.value[0]) || ve(i, c.value[0])) ? [c.value[0], i] : e.fixedEnd && (_e(i, c.value[1]) || ve(i, c.value[1])) ? [i, c.value[1]] : (n("invalid-fixed-range", i), c.value) : [], b = () => {
    e.autoApply && J.value && n("auto-apply", e.partialFlow);
  }, v = () => {
    e.autoApply && n("select-date");
  }, W = (i) => !kn({ start: i[0], end: i[1] }).some((Q) => y(Q)), se = (i) => (c.value = E($(i.value)), b()), Ne = (i) => {
    const D = Fe($(i.value), z.hours, z.minutes, j());
    e.multiDates ? k(D) : c.value = D, a(), b();
  }, Xe = () => {
    M.value = c.value ? c.value.slice() : [], M.value.length === 2 && !(e.fixedStart || e.fixedEnd) && (M.value = []);
  }, re = (i, D) => {
    const Q = [$(i.value), mt($(i.value), +e.autoRange)];
    W(Q) && (D && r(i.value), M.value = Q);
  }, qe = (i) => {
    xe(i.value) || !R(i.value, e.fixedStart ? 0 : 1) || (M.value = m($(i.value)));
  }, xe = (i) => e.noDisabledRange ? Y(M.value[0], i).some((Q) => y(Q)) : !1, Re = (i, D) => {
    if (Xe(), e.autoRange)
      return re(i, D);
    if (e.fixedStart || e.fixedEnd)
      return qe(i);
    M.value[0] ? R($(i.value)) && !xe(i.value) && (_e($(i.value), $(M.value[0])) ? M.value.unshift($(i.value)) : M.value[1] = $(i.value)) : M.value[0] = $(i.value);
  }, rt = (i) => {
    M.value[i] = Fe(
      M.value[i],
      z.hours[i],
      z.minutes[i],
      j(i !== 1)
    );
  }, ne = () => {
    M.value.length && (M.value[0] && !M.value[1] ? rt(0) : (rt(0), rt(1), a()), c.value = M.value.slice(), M.value[0] && M.value[1] && e.autoApply && n("auto-apply"), M.value[0] && !M.value[1] && e.modelAuto && e.autoApply && n("auto-apply"));
  }, me = (i, D = !1) => {
    if (!(y(i.value) || !i.current && e.hideOffsetDates)) {
      if (e.weekPicker)
        return se(i);
      if (!e.range)
        return Ne(i);
      lt(z.hours) && lt(z.minutes) && !e.multiDates && (Re(i, D), ne());
    }
  }, ge = (i) => {
    const D = i[0];
    return e.weekNumbers === "local" ? oa(D.value, { weekStartsOn: +e.weekStart }) : e.weekNumbers === "iso" ? sa(D.value) : typeof e.weekNumbers == "function" ? e.weekNumbers(D.value) : "";
  }, Je = (i) => {
    for (let D = i - 1; D >= 0; D--) {
      const Q = bt(Se($(), { month: B.value(D + 1), year: w.value(D + 1) }), 1);
      ee(D, pe(Q), ke(Q));
    }
    for (let D = i + 1; D <= A.value.multiCalendars - 1; D++) {
      const Q = st(Se($(), { month: B.value(D - 1), year: w.value(D - 1) }), 1);
      ee(D, pe(Q), ke(Q));
    }
  }, Ye = (i) => T($(), B.value(i), w.value(i)), Tt = (i) => Fe(i, z.hours, z.minutes, j()), Ht = (i) => {
    k(Ye(i));
  }, Wt = (i, D) => {
    const Q = e.monthPicker ? B.value(i) !== D.month || !D.fromNav : w.value(i) !== D.year || !D.fromNav;
    if (ee(i, D.month, D.year), A.value.multiCalendars && !e.multiCalendarsSolo && Je(i), e.monthPicker || e.yearPicker)
      if (e.multiDates)
        Q && Ht(i);
      else if (e.range) {
        if (Q && R(Ye(i))) {
          let d = c.value ? c.value.slice() : [];
          d.length === 2 && d[1] !== null && (d = []), d.length ? _e(Ye(i), d[0]) ? d.unshift(Ye(i)) : d[1] = Ye(i) : d = [Ye(i)], c.value = d;
        }
      } else
        c.value = Ye(i);
    n("update-month-year", { instance: i, month: D.month, year: D.year }), t(e.multiCalendarsSolo ? i : void 0);
  }, zt = async (i = !1) => {
    if (e.autoApply && (e.monthPicker || e.yearPicker)) {
      await dt();
      const D = e.monthPicker ? i : !1;
      e.range ? n("auto-apply", D || !c.value || c.value.length === 1) : n("auto-apply", D);
    }
    a();
  }, At = (i, D) => {
    const Q = Se($(), { month: B.value(D), year: w.value(D) }), d = i < 0 ? st(Q, 1) : bt(Q, 1);
    U(pe(d), ke(d), i < 0, e.preventMinMaxNavigation) && (ee(D, pe(d), ke(d)), A.value.multiCalendars && !e.multiCalendarsSolo && Je(D), n("update-month-year", { instance: D, month: pe(d), year: ke(d) }), t());
  }, ht = (i) => {
    On(i) && On(c.value) && lt(z.hours) && lt(z.minutes) ? (i[0] && c.value[0] && (c.value[0] = Fe(i[0], z.hours[0], z.minutes[0], j())), i[1] && c.value[1] && (c.value[1] = Fe(i[1], z.hours[1], z.minutes[1], j(!1)))) : e.multiDates && Array.isArray(c.value) ? c.value[c.value.length - 1] = Tt(i) : !e.range && !In(i) && (c.value = Tt(i)), n("time-update");
  }, xt = (i, D = !0, Q = !1) => {
    const d = D ? i : z.hours, V = !D && !Q ? i : z.minutes, we = Q ? i : z.seconds;
    if (e.range && In(c.value) && lt(d) && lt(V) && lt(we) && !e.disableTimeRangeValidation) {
      const be = (X) => Fe(c.value[X], d[X], V[X], we[X]), Ke = (X) => mn(c.value[X], 0);
      if (ve(c.value[0], c.value[1]) && (vn(be(0), Ke(1)) || fn(be(1), Ke(0))))
        return;
    }
    if (x("hours", d), x("minutes", V), x("seconds", we), c.value)
      if (e.multiDates) {
        const be = l();
        be && ht(be);
      } else
        ht(c.value);
    else
      e.timePicker && ht(e.range ? [$(), $()] : $());
    a();
  }, Kt = (i, D) => {
    e.monthChangeOnScroll && At(e.monthChangeOnScroll !== "inverse" ? -i.deltaY : i.deltaY, D);
  }, jt = (i, D, Q = !1) => {
    e.monthChangeOnArrows && e.vertical === Q && St(i, D);
  }, St = (i, D) => {
    At(i === "right" ? -1 : 1, D);
  };
  return {
    time: z,
    month: B,
    year: w,
    modelValue: c,
    calendars: H,
    monthYearSelect: zt,
    isDisabled: y,
    updateTime: xt,
    getWeekNum: ge,
    selectDate: me,
    updateMonthYear: Wt,
    handleScroll: Kt,
    getMarker: (i) => e.markers.find((D) => ve(_(i.value), _(D.date))),
    handleArrow: jt,
    handleSwipe: St,
    selectCurrentDate: () => {
      e.range ? c.value && Array.isArray(c.value) && c.value[0] ? c.value = _e($(), c.value[0]) ? [$(), c.value[0]] : [c.value[0], $()] : c.value = [$()] : c.value = $(), v();
    },
    presetDateRange: (i, D) => {
      D || i.length && i.length <= 2 && e.range && (c.value = i.map((Q) => $(Q)), v(), e.multiCalendars && dt().then(() => le(!0)));
    }
  };
}, er = (e, n, a) => {
  const t = L(), {
    getZonedToUtc: s,
    getZonedDate: f,
    formatDate: y,
    getDefaultPattern: _,
    checkRangeEnabled: E,
    checkPartialRangeValue: T,
    isValidDate: U,
    setDateMonthOrYear: A,
    defaults: c
  } = Ee(n), M = L(""), te = $t(n, "format");
  tt(t, () => {
    e("internal-model-change", t.value);
  }), tt(te, () => {
    o();
  });
  const H = (v) => {
    const W = v || $();
    return n.modelType ? r(W) : {
      hours: je(W),
      minutes: Ge(W),
      seconds: n.enableSeconds ? yt(W) : 0
    };
  }, z = (v) => n.modelType ? r(v) : { month: pe(v), year: ke(v) }, B = (v) => Array.isArray(v) ? E(() => [
    ut($(), v[0]),
    v[1] ? ut($(), v[1]) : T()
  ]) : ut($(), +v), w = (v, W) => (typeof v == "string" || typeof v == "number") && n.modelType ? g(v) : W, J = (v) => Array.isArray(v) ? [
    w(
      v[0],
      Fe(null, +v[0].hours, +v[0].minutes, v[0].seconds)
    ),
    w(
      v[1],
      Fe(null, +v[1].hours, +v[1].minutes, v[1].seconds)
    )
  ] : w(v, Fe(null, v.hours, v.minutes, v.seconds)), ee = (v) => Array.isArray(v) ? n.multiDates ? v.map((W) => w(W, A(null, +W.month, +W.year))) : E(() => [
    w(v[0], A(null, +v[0].month, +v[0].year)),
    w(
      v[1],
      v[1] ? A(null, +v[1].month, +v[1].year) : T()
    )
  ]) : w(v, A(null, +v.month, +v.year)), x = (v) => {
    if (Array.isArray(v))
      return v.map((W) => g(W));
    throw new Error(Ft.dateArr("multi-dates"));
  }, le = (v) => {
    if (Array.isArray(v))
      return [$(v[0]), $(v[1])];
    throw new Error(Ft.dateArr("week-picker"));
  }, de = (v) => n.modelAuto ? Array.isArray(v) ? [g(v[0]), g(v[1])] : n.autoApply ? [g(v)] : [g(v), null] : Array.isArray(v) ? E(() => [
    g(v[0]),
    v[1] ? g(v[1]) : T()
  ]) : g(v), C = () => {
    Array.isArray(t.value) && n.range && t.value.length === 1 && t.value.push(T());
  }, N = () => {
    const v = t.value;
    return [
      r(v[0]),
      v[1] ? r(v[1]) : T()
    ];
  }, G = () => t.value[1] ? N() : r(Me(t.value[0])), P = () => (t.value || []).map((v) => r(v)), Z = () => (C(), n.modelAuto ? G() : n.multiDates ? P() : Array.isArray(t.value) ? E(() => N()) : r(Me(t.value))), p = (v) => v ? n.timePicker ? J(Me(v)) : n.monthPicker ? ee(Me(v)) : n.yearPicker ? B(Me(v)) : n.multiDates ? x(Me(v)) : n.weekPicker ? le(Me(v)) : de(Me(v)) : null, q = (v) => {
    const W = p(v);
    U(Me(W)) ? (t.value = Me(W), o()) : (t.value = null, M.value = "");
  }, j = () => {
    var W;
    const v = (se) => {
      var Ne;
      return wt(se, (Ne = c.value.textInputOptions) == null ? void 0 : Ne.format);
    };
    return `${v(t.value[0])} ${(W = c.value.textInputOptions) == null ? void 0 : W.rangeSeparator} ${t.value[1] ? v(t.value[1]) : ""}`;
  }, I = () => {
    var v;
    return a.value && t.value ? Array.isArray(t.value) ? j() : wt(t.value, (v = c.value.textInputOptions) == null ? void 0 : v.format) : y(t.value);
  }, l = () => {
    var v;
    return t.value ? n.multiDates ? t.value.map((W) => y(W)).join("; ") : n.textInput && typeof ((v = c.value.textInputOptions) == null ? void 0 : v.format) == "string" ? I() : y(t.value) : "";
  }, o = () => {
    !n.format || typeof n.format == "string" ? M.value = l() : M.value = n.format(t.value);
  }, g = (v) => {
    if (n.utc) {
      const W = new Date(v);
      return n.utc === "preserve" ? new Date(W.getTime() + W.getTimezoneOffset() * 6e4) : W;
    }
    return n.modelType ? n.modelType === "date" || n.modelType === "timestamp" ? f(new Date(v)) : n.modelType === "format" && (typeof n.format == "string" || !n.format) ? on(v, _(), /* @__PURE__ */ new Date()) : f(on(v, n.modelType, /* @__PURE__ */ new Date())) : f(new Date(v));
  }, r = (v) => v ? n.utc ? ma(v, n.utc === "preserve") : n.modelType ? n.modelType === "timestamp" ? +s(v) : n.modelType === "format" && (typeof n.format == "string" || !n.format) ? y(s(v)) : y(s(v), n.modelType) : s(v) : "", k = (v) => {
    e("update:model-value", v);
  }, Y = (v) => Array.isArray(t.value) ? n.multiDates ? t.value.map((W) => v(W)) : [
    v(t.value[0]),
    t.value[1] ? v(t.value[1]) : T()
  ] : v(Me(t.value)), R = (v) => k(Me(Y(v)));
  return {
    inputValue: M,
    internalModelValue: t,
    checkBeforeEmit: () => t.value ? n.range ? n.partialRange ? t.value.length >= 1 : t.value.length === 2 : !!t.value : !1,
    parseExternalModelValue: q,
    formatInputValue: o,
    emitModelValue: () => (o(), n.monthPicker ? R(z) : n.timePicker ? R(H) : n.yearPicker ? R(ke) : n.weekPicker ? k(t.value) : k(Z()))
  };
}, tr = (e, n) => {
  const { validateMonthYearInRange: a, validateMaxDate: t, validateMinDate: s, defaults: f } = Ee(e), y = (A, c) => {
    let M = A;
    return f.value.filters.months.includes(pe(M)) ? (M = c ? st(A, 1) : bt(A, 1), y(M, c)) : M;
  }, _ = (A, c) => {
    let M = A;
    return f.value.filters.years.includes(ke(M)) ? (M = c ? ua(A, 1) : da(A, 1), _(M, c)) : M;
  }, E = (A) => {
    const c = Se(/* @__PURE__ */ new Date(), { month: e.month, year: e.year });
    let M = A ? st(c, 1) : bt(c, 1), te = pe(M), H = ke(M);
    f.value.filters.months.includes(te) && (M = y(M, A), te = pe(M), H = ke(M)), f.value.filters.years.includes(H) && (M = _(M, A), H = ke(M)), a(te, H, A, e.preventMinMaxNavigation) && T(te, H);
  }, T = (A, c) => {
    n("update-month-year", { month: A, year: c });
  }, U = F(() => (A) => {
    if (!e.preventMinMaxNavigation || A && !e.maxDate || !A && !e.minDate)
      return !1;
    const c = Se(/* @__PURE__ */ new Date(), { month: e.month, year: e.year }), M = A ? st(c, 1) : bt(c, 1), te = [pe(M), ke(M)];
    return A ? !t(...te) : !s(...te);
  });
  return { handleMonthYearChange: E, isDisabled: U, updateMonthYear: T };
};
var It = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(It || {});
const nr = (e, n, a, t) => {
  const s = L({
    top: "0",
    left: "0",
    transform: "none"
  }), f = L(!1), y = $t(t, "teleportCenter");
  tt(y, () => {
    H();
  });
  const _ = (C) => {
    if (t.teleport) {
      const N = C.getBoundingClientRect();
      return {
        left: N.left + window.scrollX,
        top: N.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, E = (C, N) => {
    s.value.left = `${C + N}px`, s.value.transform = "translateX(-100%)";
  }, T = (C) => {
    s.value.left = `${C}px`, s.value.transform = "translateX(0)";
  }, U = (C, N, G = !1) => {
    t.position === It.left && T(C), t.position === It.right && E(C, N), t.position === It.center && (s.value.left = `${C + N / 2}px`, s.value.transform = G ? "translate(-50%, -50%)" : "translateX(-50%)");
  }, A = (C) => {
    const { width: N, height: G } = C.getBoundingClientRect(), { top: P, left: Z } = t.altPosition ? t.altPosition(C) : _(C);
    return { top: +P, left: +Z, width: N, height: G };
  }, c = () => {
    const C = $e(n);
    if (C) {
      const { top: N, left: G, width: P, height: Z } = A(C);
      s.value.top = `${N + Z / 2}px`, s.value.transform = "translateY(-50%)", U(G, P, !0);
    }
  }, M = () => {
    s.value.left = "50%", s.value.top = "50%", s.value.transform = "translate(-50%, -50%)", s.value.position = "fixed";
  }, te = () => {
    const C = $e(n), { top: N, left: G, transform: P } = t.altPosition(C);
    s.value = { top: `${N}px`, left: `${G}px`, transform: P || "" };
  }, H = (C = !0) => {
    if (!t.inline)
      return y.value ? M() : t.altPosition !== null ? te() : (C && a("recalculate-position"), x());
  }, z = ({
    inputEl: C,
    menuEl: N,
    left: G,
    width: P
  }) => {
    window.screen.width > 768 && U(G, P), J(C, N);
  }, B = (C, N) => {
    const { top: G, left: P, height: Z, width: p } = A(C);
    s.value.top = `${Z + G + +t.offset}px`, z({ inputEl: C, menuEl: N, left: P, width: p }), f.value = !1;
  }, w = (C, N) => {
    const { top: G, left: P, width: Z } = A(C), { height: p } = N.getBoundingClientRect();
    s.value.top = `${G - p - +t.offset}px`, z({ inputEl: C, menuEl: N, left: P, width: Z }), f.value = !0;
  }, J = (C, N) => {
    if (t.autoPosition) {
      const { left: G, width: P } = A(C), { left: Z, right: p } = N.getBoundingClientRect();
      return Z <= 0 || Z <= G ? T(G) : p >= document.documentElement.clientWidth ? E(G, P) : U(G, P);
    }
  }, ee = (C, N) => {
    const { height: G } = N.getBoundingClientRect(), { top: P, height: Z } = C.getBoundingClientRect(), q = window.innerHeight - P - Z, j = P;
    return G <= q ? B(C, N) : G > q && G <= j ? w(C, N) : q >= j ? B(C, N) : w(C, N);
  }, x = () => {
    const C = $e(n), N = $e(e);
    if (C && N)
      return t.autoPosition ? ee(C, N) : B(C, N);
  }, le = function(C) {
    if (C) {
      const N = C.scrollHeight > C.clientHeight, P = window.getComputedStyle(C).overflowY.indexOf("hidden") !== -1;
      return N && !P;
    }
    return !0;
  }, de = function(C) {
    return !C || C === document.body || C.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : le(C) ? C : de(C.parentNode);
  };
  return { openOnTop: f, menuPosition: s, setMenuPosition: H, setInitialPosition: c, getScrollableParent: de };
}, vt = [
  { name: "clock-icon", use: ["time", "calendar"] },
  { name: "arrow-left", use: ["month-year", "calendar"] },
  { name: "arrow-right", use: ["month-year", "calendar"] },
  { name: "arrow-up", use: ["time", "calendar"] },
  { name: "arrow-down", use: ["time", "calendar"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar"] },
  { name: "day", use: ["calendar"] },
  { name: "month-overlay-value", use: ["calendar", "month-year"] },
  { name: "year-overlay-value", use: ["calendar", "month-year"] },
  { name: "year-overlay", use: ["month-year"] },
  { name: "month-overlay", use: ["month-year"] },
  { name: "month-overlay-header", use: ["month-year"] },
  { name: "year-overlay-header", use: ["month-year"] },
  { name: "hours-overlay-value", use: ["calendar", "time"] },
  { name: "minutes-overlay-value", use: ["calendar", "time"] },
  { name: "seconds-overlay-value", use: ["calendar", "time"] },
  { name: "hours", use: ["calendar", "time"] },
  { name: "minutes", use: ["calendar", "time"] },
  { name: "month", use: ["calendar", "month-year"] },
  { name: "year", use: ["calendar", "month-year"] },
  { name: "action-select", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar"] },
  { name: "marker-tooltip", use: ["calendar"] },
  { name: "now-button", use: [] },
  { name: "time-picker-overlay", use: ["calendar", "time"] },
  { name: "am-pm-button", use: ["calendar", "time"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year"] },
  { name: "time-picker", use: ["menu"] },
  { name: "action-row", use: ["action"] }
], ar = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], rr = {
  all: () => vt,
  monthYear: () => vt.filter((e) => e.use.includes("month-year")),
  input: () => ar,
  timePicker: () => vt.filter((e) => e.use.includes("time")),
  action: () => vt.filter((e) => e.use.includes("action")),
  calendar: () => vt.filter((e) => e.use.includes("calendar")),
  menu: () => vt.filter((e) => e.use.includes("menu"))
}, it = (e, n, a) => {
  const t = [];
  return rr[n]().forEach((s) => {
    e[s.name] && t.push(s.name);
  }), a && a.length && a.forEach((s) => {
    s.slot && t.push(s.slot);
  }), t;
}, Ut = (e) => ({ transitionName: F(() => (a) => e && typeof e != "boolean" ? a ? e.open : e.close : ""), showTransition: !!e }), at = {
  multiCalendars: { type: [Boolean, Number, String], default: null },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  closeOnScroll: { type: Boolean, default: !1 },
  autoPosition: { type: Boolean, default: !0 },
  closeOnAutoApply: { type: Boolean, default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: String, default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  menuClassName: { type: String, default: null },
  dayClass: { type: Function, default: null },
  yearRange: { type: Array, default: () => [1900, 2100] },
  multiCalendarsSolo: { type: Boolean, default: !1 },
  calendarCellClassName: { type: String, default: null },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  autoRange: { type: [Number, String], default: null },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: () => [] },
  showNowButton: { type: Boolean, default: !1 },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  modeHeight: { type: [Number, String], default: 255 },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetRanges: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  minRange: { type: [Number, String], default: null },
  maxRange: { type: [Number, String], default: null },
  multiDatesLimit: { type: [Number, String], default: null },
  reverseYears: { type: Boolean, default: !1 },
  keepActionRow: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  multiStatic: { type: Boolean, default: !0 },
  disableTimeRangeValidation: { type: Boolean, default: !1 },
  highlight: {
    type: [Array, Function],
    default: null
  },
  highlightWeekDays: {
    type: Array,
    default: null
  },
  highlightDisabledDays: { type: Boolean, default: !1 },
  teleport: { type: [String, Boolean], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function],
    default: null
  },
  calendarClassName: { type: String, default: null },
  noSwipe: { type: Boolean, default: !1 },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: Boolean, default: !1 },
  partialRange: { type: Boolean, default: !0 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  inputClassName: { type: String, default: null },
  inlineWithInput: { type: Boolean, default: !1 },
  textInputOptions: { type: Object, default: () => null },
  fixedStart: { type: Boolean, default: !1 },
  fixedEnd: { type: Boolean, default: !1 },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: Boolean, default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: Boolean, default: !1 },
  textInput: { type: Boolean, default: !1 },
  onClickOutside: { type: Function, default: null },
  noDisabledRange: { type: Boolean, default: !1 },
  sixWeeks: { type: Boolean, default: !1 }
}, lr = ["aria-label", "aria-disabled", "aria-readonly"], or = {
  key: 1,
  class: "dp__input_wrap"
}, sr = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "onKeydown"], ir = {
  key: 2,
  class: "dp__input_icon"
}, ur = {
  key: 4,
  class: "dp__clear_icon"
}, dr = /* @__PURE__ */ We({
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...at
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur"
  ],
  setup(e, { expose: n, emit: a }) {
    const t = e, { getDefaultPattern: s, isValidDate: f, defaults: y, getDefaultStartTime: _, assignDefaultTime: E } = Ee(t), T = L(), U = L(null), A = L(!1), c = L(!1), M = F(
      () => ({
        dp__pointer: !t.disabled && !t.readonly && !t.textInput,
        dp__disabled: t.disabled,
        dp__input_readonly: !t.textInput,
        dp__input: !0,
        dp__input_icon_pad: !t.hideInputIcon,
        dp__input_valid: t.state,
        dp__input_invalid: t.state === !1,
        dp__input_focus: A.value || t.isMenuOpen,
        dp__input_reg: !t.textInput,
        [t.inputClassName]: !!t.inputClassName
      })
    ), te = () => {
      a("set-input-date", null), t.autoApply && (a("set-empty-date"), T.value = null);
    }, H = (p) => {
      var j;
      const q = _();
      return va(
        p,
        ((j = y.value.textInputOptions) == null ? void 0 : j.format) || s(),
        q || E({}),
        t.inputValue,
        c.value
      );
    }, z = (p) => {
      const { rangeSeparator: q } = y.value.textInputOptions, [j, I] = p.split(`${q}`);
      if (j) {
        const l = H(j.trim()), o = I ? H(I.trim()) : null, g = l && o ? [l, o] : [l];
        T.value = l ? g : null;
      }
    }, B = () => {
      c.value = !0;
    }, w = (p) => {
      if (t.range)
        z(p);
      else if (t.multiDates) {
        const q = p.split(";");
        T.value = q.map((j) => H(j.trim())).filter((j) => j);
      } else
        T.value = H(p);
    }, J = (p) => {
      var j;
      const { value: q } = p.target;
      q !== "" ? ((j = y.value.textInputOptions) != null && j.openMenu && !t.isMenuOpen && a("open"), w(q), a("set-input-date", T.value)) : te(), c.value = !1, a("update:input-value", q);
    }, ee = () => {
      var p, q;
      (p = y.value.textInputOptions) != null && p.enterSubmit && f(T.value) && t.inputValue !== "" ? (a("set-input-date", T.value, !0), T.value = null) : (q = y.value.textInputOptions) != null && q.enterSubmit && t.inputValue === "" && (T.value = null, a("clear"));
    }, x = () => {
      var p, q;
      (p = y.value.textInputOptions) != null && p.tabSubmit && f(T.value) && t.inputValue !== "" ? (a("set-input-date", T.value, !0), T.value = null) : (q = y.value.textInputOptions) != null && q.tabSubmit && t.inputValue === "" && (T.value = null, a("clear"));
    }, le = () => {
      A.value = !0, a("focus");
    }, de = (p) => {
      var q;
      p.preventDefault(), p.stopImmediatePropagation(), p.stopPropagation(), t.textInput && ((q = y.value.textInputOptions) != null && q.openMenu) && !t.inlineWithInput ? t.isMenuOpen ? y.value.textInputOptions.enterSubmit && a("select-date") : a("open") : t.textInput || a("toggle");
    }, C = () => {
      A.value = !1, t.isMenuOpen || a("blur"), t.autoApply && t.textInput && T.value && (a("set-input-date", T.value), a("select-date"), T.value = null);
    }, N = () => {
      a("clear");
    }, G = (p) => {
      if (!t.textInput) {
        if (p.code === "Tab")
          return;
        p.preventDefault();
      }
    };
    return n({
      focusInput: () => {
        U.value && U.value.focus({ preventScroll: !0 });
      },
      setParsedDate: (p) => {
        T.value = p;
      }
    }), (p, q) => {
      var j;
      return h(), O("div", {
        onClick: de,
        "aria-label": (j = u(y).ariaLabels) == null ? void 0 : j.input,
        role: "textbox",
        "aria-multiline": "false",
        "aria-disabled": p.disabled,
        "aria-readonly": p.readonly
      }, [
        p.$slots.trigger && !p.$slots["dp-input"] && !p.inline ? K(p.$slots, "trigger", { key: 0 }) : S("", !0),
        !p.$slots.trigger && (!p.inline || p.inlineWithInput) ? (h(), O("div", or, [
          p.$slots["dp-input"] && !p.$slots.trigger && !p.inline ? K(p.$slots, "dp-input", {
            key: 0,
            value: e.inputValue,
            onInput: J,
            onEnter: ee,
            onTab: x,
            onClear: N,
            onBlur: C
          }) : S("", !0),
          p.$slots["dp-input"] ? S("", !0) : (h(), O("input", {
            key: 1,
            ref_key: "inputRef",
            ref: U,
            id: p.uid ? `dp-input-${p.uid}` : void 0,
            name: p.name,
            class: ye(u(M)),
            inputmode: p.textInput ? "text" : "none",
            placeholder: p.placeholder,
            disabled: p.disabled,
            readonly: p.readonly,
            required: p.required,
            value: e.inputValue,
            autocomplete: p.autocomplete,
            onInput: J,
            onKeydown: [
              ue(de, ["enter"]),
              ue(x, ["tab"]),
              G
            ],
            onBlur: C,
            onFocus: le,
            onKeypress: G,
            onPaste: B
          }, null, 42, sr)),
          p.$slots["input-icon"] && !p.hideInputIcon ? (h(), O("span", ir, [
            K(p.$slots, "input-icon")
          ])) : S("", !0),
          !p.$slots["input-icon"] && !p.hideInputIcon && !p.$slots["dp-input"] ? (h(), fe(u(Lt), {
            key: 3,
            class: "dp__input_icon dp__input_icons"
          })) : S("", !0),
          p.$slots["clear-icon"] && e.inputValue && p.clearable && !p.disabled && !p.readonly ? (h(), O("span", ur, [
            K(p.$slots, "clear-icon", { clear: N })
          ])) : S("", !0),
          p.clearable && !p.$slots["clear-icon"] && e.inputValue && !p.disabled && !p.readonly ? (h(), fe(u(fa), {
            key: 5,
            class: "dp__clear_icon dp__input_icons",
            "data-test": "clear-icon",
            onClick: Ze(N, ["stop", "prevent"])
          }, null, 8, ["onClick"])) : S("", !0)
        ])) : S("", !0)
      ], 8, lr);
    };
  }
}), cr = ["title"], fr = { class: "dp__action_buttons" }, vr = ["onKeydown", "disabled"], mr = /* @__PURE__ */ We({
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    calendarWidth: { type: Number, default: 0 },
    ...at
  },
  emits: ["close-picker", "select-date", "invalid-select"],
  setup(e, { emit: n }) {
    const a = e, { formatDate: t, isValidTime: s, defaults: f } = Ee(a), { buildMatrix: y } = nt(), _ = L(null), E = L(null);
    He(() => {
      a.arrowNavigation && y([$e(_), $e(E)], "actionRow");
    });
    const T = F(() => a.range && !a.partialRange && a.internalModelValue ? a.internalModelValue.length === 2 : !0), U = F(() => !A.value || !c.value || !T.value), A = F(() => !a.enableTimePicker || a.ignoreTimeValidation ? !0 : s(a.internalModelValue)), c = F(() => a.monthPicker ? a.range && Array.isArray(a.internalModelValue) ? !a.internalModelValue.filter((J) => !z(J)).length : z(a.internalModelValue) : !0), M = () => {
      const w = f.value.previewFormat;
      return a.timePicker || a.monthPicker, w(Me(a.internalModelValue));
    }, te = () => {
      const w = a.internalModelValue;
      return f.value.multiCalendars > 0 ? `${t(w[0])} - ${t(w[1])}` : [t(w[0]), t(w[1])];
    }, H = F(() => !a.internalModelValue || !a.menuMount ? "" : typeof f.value.previewFormat == "string" ? Array.isArray(a.internalModelValue) ? a.internalModelValue.length === 2 && a.internalModelValue[1] ? te() : a.multiDates ? a.internalModelValue.map((w) => `${t(w)}`) : a.modelAuto ? `${t(a.internalModelValue[0])}` : `${t(a.internalModelValue[0])} -` : t(a.internalModelValue) : M()), z = (w) => {
      if (!a.monthPicker)
        return !0;
      let J = !0;
      const ee = $(pt(w));
      if (a.minDate && a.maxDate) {
        const x = $(pt(a.minDate)), le = $(pt(a.maxDate));
        return Be(ee, x) && _e(ee, le) || ve(ee, x) || ve(ee, le);
      }
      if (a.minDate) {
        const x = $(pt(a.minDate));
        J = Be(ee, x) || ve(ee, x);
      }
      if (a.maxDate) {
        const x = $(pt(a.maxDate));
        J = _e(ee, x) || ve(ee, x);
      }
      return J;
    }, B = () => {
      A.value && c.value && T.value ? n("select-date") : n("invalid-select");
    };
    return (w, J) => (h(), O("div", {
      class: "dp__action_row",
      style: Qe(e.calendarWidth ? { width: `${e.calendarWidth}px` } : {})
    }, [
      w.$slots["action-row"] ? K(w.$slots, "action-row", Pe(Te({ key: 0 }, {
        internalModelValue: e.internalModelValue,
        disabled: u(U),
        selectDate: () => w.$emit("select-date"),
        closePicker: () => w.$emit("close-picker")
      }))) : (h(), O(ce, { key: 1 }, [
        ae("div", {
          class: "dp__selection_preview",
          title: Array.isArray(u(H)) ? "" : u(H)
        }, [
          w.$slots["action-preview"] ? K(w.$slots, "action-preview", {
            key: 0,
            value: e.internalModelValue
          }) : S("", !0),
          w.$slots["action-preview"] ? S("", !0) : (h(), O(ce, { key: 1 }, [
            Array.isArray(u(H)) ? S("", !0) : (h(), O(ce, { key: 0 }, [
              ze(Ce(u(H)), 1)
            ], 64)),
            Array.isArray(u(H)) ? (h(!0), O(ce, { key: 1 }, De(u(H), (ee, x) => (h(), O("div", { key: x }, Ce(ee), 1))), 128)) : S("", !0)
          ], 64))
        ], 8, cr),
        ae("div", fr, [
          w.$slots["action-select"] ? K(w.$slots, "action-select", {
            key: 0,
            value: e.internalModelValue
          }) : S("", !0),
          w.$slots["action-select"] ? S("", !0) : (h(), O(ce, { key: 1 }, [
            w.inline ? S("", !0) : (h(), O("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: _,
              class: "dp__action_button dp__action_cancel",
              onClick: J[0] || (J[0] = (ee) => w.$emit("close-picker")),
              onKeydown: [
                J[1] || (J[1] = ue((ee) => w.$emit("close-picker"), ["enter"])),
                J[2] || (J[2] = ue((ee) => w.$emit("close-picker"), ["space"]))
              ]
            }, Ce(w.cancelText), 545)),
            ae("button", {
              class: "dp__action_button dp__action_select",
              onKeydown: [
                ue(B, ["enter"]),
                ue(B, ["space"])
              ],
              onClick: B,
              disabled: u(U),
              "data-test": "select-button",
              ref_key: "selectButtonRef",
              ref: E
            }, Ce(w.selectText), 41, vr)
          ], 64))
        ])
      ], 64))
    ], 4));
  }
}), yr = ["aria-label"], gr = {
  class: "dp__calendar_header",
  role: "row"
}, hr = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, pr = /* @__PURE__ */ ae("div", { class: "dp__calendar_header_separator" }, null, -1), kr = ["aria-label"], wr = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
}, br = { class: "dp__cell_inner" }, Dr = ["aria-selected", "aria-disabled", "aria-label", "data-test", "onClick", "onKeydown", "onMouseenter", "onMouseleave"], $r = /* @__PURE__ */ We({
  __name: "Calendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    getWeekNum: {
      type: Function,
      default: () => ""
    },
    specificMode: { type: Boolean, default: !1 },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...at
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: n, emit: a }) {
    const t = e, { buildMultiLevelMatrix: s } = nt(), { setDateMonthOrYear: f, defaults: y } = Ee(t), _ = L(null), E = L({
      bottom: "",
      left: "",
      transform: ""
    }), T = L([]), U = L(null), A = L(!0), c = L(""), M = L({ startX: 0, endX: 0, startY: 0, endY: 0 }), te = L([]), H = L({ left: "50%" }), z = F(() => t.dayNames ? Array.isArray(t.dayNames) ? t.dayNames : t.dayNames(t.locale, +t.weekStart) : Ha(t.locale, +t.weekStart));
    He(() => {
      a("mount", { cmp: "calendar", refs: T }), t.noSwipe || U.value && (U.value.addEventListener("touchstart", P, { passive: !1 }), U.value.addEventListener("touchend", Z, { passive: !1 }), U.value.addEventListener("touchmove", p, { passive: !1 })), t.monthChangeOnScroll && U.value && U.value.addEventListener("wheel", I, { passive: !1 });
    });
    const B = (l) => l ? t.vertical ? "vNext" : "next" : t.vertical ? "vPrevious" : "previous", w = (l, o) => {
      if (t.transitions) {
        const g = Ue(f($(), t.month, t.year));
        c.value = Be(Ue(f($(), l, o)), g) ? y.value.transitions[B(!0)] : y.value.transitions[B(!1)], A.value = !1, dt(() => {
          A.value = !0;
        });
      }
    }, J = F(
      () => ({
        dp__calendar_wrap: !0,
        [t.calendarClassName]: !!t.calendarClassName
      })
    ), ee = F(() => (l) => {
      const o = Ka(l);
      return {
        dp__marker_dot: o.type === "dot",
        dp__marker_line: o.type === "line"
      };
    }), x = F(() => (l) => ve(l, _.value)), le = F(() => ({
      dp__calendar: !0,
      dp__calendar_next: y.value.multiCalendars > 0 && t.instance !== 0
    })), de = F(() => (l) => t.hideOffsetDates ? l.current : !0), C = F(() => t.specificMode ? { height: `${t.modeHeight}px` } : void 0), N = async (l, o, g) => {
      var r, k;
      if (a("set-hover-date", l), (k = (r = l.marker) == null ? void 0 : r.tooltip) != null && k.length) {
        const Y = $e(T.value[o][g]);
        if (Y) {
          const { width: R, height: m } = Y.getBoundingClientRect();
          _.value = l.value;
          let b = { left: `${R / 2}px` }, v = -50;
          if (await dt(), te.value[0]) {
            const { left: W, width: se } = te.value[0].getBoundingClientRect();
            W < 0 && (b = { left: "0" }, v = 0, H.value.left = `${R / 2}px`), window.innerWidth < W + se && (b = { right: "0" }, v = 0, H.value.left = `${se - R / 2}px`);
          }
          E.value = {
            bottom: `${m}px`,
            ...b,
            transform: `translateX(${v}%)`
          }, a("tooltip-open", l.marker);
        }
      }
    }, G = (l) => {
      _.value && (_.value = null, E.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), a("tooltip-close", l.marker));
    }, P = (l) => {
      M.value.startX = l.changedTouches[0].screenX, M.value.startY = l.changedTouches[0].screenY;
    }, Z = (l) => {
      M.value.endX = l.changedTouches[0].screenX, M.value.endY = l.changedTouches[0].screenY, q();
    }, p = (l) => {
      t.vertical && !t.inline && l.preventDefault();
    }, q = () => {
      const l = t.vertical ? "Y" : "X";
      Math.abs(M.value[`start${l}`] - M.value[`end${l}`]) > 10 && a("handle-swipe", M.value[`start${l}`] > M.value[`end${l}`] ? "right" : "left");
    }, j = (l, o, g) => {
      l && (Array.isArray(T.value[o]) ? T.value[o][g] = l : T.value[o] = [l]), t.arrowNavigation && s(T.value, "calendar");
    }, I = (l) => {
      t.monthChangeOnScroll && (l.preventDefault(), a("handle-scroll", l));
    };
    return n({ triggerTransition: w }), (l, o) => {
      var g;
      return h(), O("div", {
        class: ye(u(le))
      }, [
        ae("div", {
          style: Qe(u(C))
        }, [
          e.specificMode ? S("", !0) : (h(), O("div", {
            key: 0,
            ref_key: "calendarWrapRef",
            ref: U,
            class: ye(u(J)),
            role: "grid",
            "aria-label": (g = u(y).ariaLabels) == null ? void 0 : g.calendarWrap
          }, [
            ae("div", gr, [
              l.weekNumbers ? (h(), O("div", hr, Ce(l.weekNumName), 1)) : S("", !0),
              (h(!0), O(ce, null, De(u(z), (r, k) => (h(), O("div", {
                class: "dp__calendar_header_item",
                role: "gridcell",
                key: k,
                "data-test": "calendar-header"
              }, [
                l.$slots["calendar-header"] ? K(l.$slots, "calendar-header", {
                  key: 0,
                  day: r,
                  index: k
                }) : S("", !0),
                l.$slots["calendar-header"] ? S("", !0) : (h(), O(ce, { key: 1 }, [
                  ze(Ce(r), 1)
                ], 64))
              ]))), 128))
            ]),
            pr,
            et(gt, {
              name: c.value,
              css: !!l.transitions
            }, {
              default: oe(() => {
                var r;
                return [
                  A.value ? (h(), O("div", {
                    key: 0,
                    class: "dp__calendar",
                    role: "grid",
                    "aria-label": (r = u(y).ariaLabels) == null ? void 0 : r.calendarDays
                  }, [
                    (h(!0), O(ce, null, De(e.mappedDates, (k, Y) => (h(), O("div", {
                      class: "dp__calendar_row",
                      role: "row",
                      key: Y
                    }, [
                      l.weekNumbers ? (h(), O("div", wr, [
                        ae("div", br, Ce(e.getWeekNum(k.days)), 1)
                      ])) : S("", !0),
                      (h(!0), O(ce, null, De(k.days, (R, m) => {
                        var b, v, W;
                        return h(), O("div", {
                          role: "gridcell",
                          class: "dp__calendar_item",
                          ref_for: !0,
                          ref: (se) => j(se, Y, m),
                          key: m + Y,
                          "aria-selected": R.classData.dp__active_date || R.classData.dp__range_start || R.classData.dp__range_start,
                          "aria-disabled": R.classData.dp__cell_disabled,
                          "aria-label": (v = (b = u(y).ariaLabels) == null ? void 0 : b.day) == null ? void 0 : v.call(b, R),
                          tabindex: "0",
                          "data-test": R.value,
                          onClick: Ze((se) => l.$emit("select-date", R), ["stop", "prevent"]),
                          onKeydown: [
                            ue((se) => l.$emit("select-date", R), ["enter"]),
                            ue((se) => l.$emit("handle-space", R), ["space"])
                          ],
                          onMouseenter: (se) => N(R, Y, m),
                          onMouseleave: (se) => G(R)
                        }, [
                          ae("div", {
                            class: ye(["dp__cell_inner", R.classData])
                          }, [
                            l.$slots.day && u(de)(R) ? K(l.$slots, "day", {
                              key: 0,
                              day: +R.text,
                              date: R.value
                            }) : S("", !0),
                            l.$slots.day ? S("", !0) : (h(), O(ce, { key: 1 }, [
                              ze(Ce(R.text), 1)
                            ], 64)),
                            R.marker && u(de)(R) ? (h(), O("div", {
                              key: 2,
                              class: ye(u(ee)(R.marker)),
                              style: Qe(R.marker.color ? { backgroundColor: R.marker.color } : {})
                            }, null, 6)) : S("", !0),
                            u(x)(R.value) ? (h(), O("div", {
                              key: 3,
                              class: "dp__marker_tooltip",
                              ref_for: !0,
                              ref_key: "activeTooltip",
                              ref: te,
                              style: Qe(E.value)
                            }, [
                              (W = R.marker) != null && W.tooltip ? (h(), O("div", {
                                key: 0,
                                class: "dp__tooltip_content",
                                onClick: o[0] || (o[0] = Ze(() => {
                                }, ["stop"]))
                              }, [
                                (h(!0), O(ce, null, De(R.marker.tooltip, (se, Ne) => (h(), O("div", {
                                  key: Ne,
                                  class: "dp__tooltip_text"
                                }, [
                                  l.$slots["marker-tooltip"] ? K(l.$slots, "marker-tooltip", {
                                    key: 0,
                                    tooltip: se,
                                    day: R.value
                                  }) : S("", !0),
                                  l.$slots["marker-tooltip"] ? S("", !0) : (h(), O(ce, { key: 1 }, [
                                    ae("div", {
                                      class: "dp__tooltip_mark",
                                      style: Qe(se.color ? { backgroundColor: se.color } : {})
                                    }, null, 4),
                                    ae("div", null, Ce(se.text), 1)
                                  ], 64))
                                ]))), 128)),
                                ae("div", {
                                  class: "dp__arrow_bottom_tp",
                                  style: Qe(H.value)
                                }, null, 4)
                              ])) : S("", !0)
                            ], 4)) : S("", !0)
                          ], 2)
                        ], 40, Dr);
                      }), 128))
                    ]))), 128))
                  ], 8, kr)) : S("", !0)
                ];
              }),
              _: 3
            }, 8, ["name", "css"])
          ], 10, yr))
        ], 4)
      ], 2);
    };
  }
}), Mr = ["aria-label", "aria-disabled"], rn = /* @__PURE__ */ We({
  __name: "ActionIcon",
  props: {
    ariaLabel: { type: String, default: "" },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: n }) {
    const a = L(null);
    return He(() => n("set-ref", a)), (t, s) => (h(), O("div", {
      class: "dp__month_year_col_nav",
      onClick: s[0] || (s[0] = (f) => t.$emit("activate")),
      onKeydown: [
        s[1] || (s[1] = ue((f) => t.$emit("activate"), ["enter"])),
        s[2] || (s[2] = ue((f) => t.$emit("activate"), ["space"]))
      ],
      tabindex: "0",
      role: "button",
      "aria-label": e.ariaLabel,
      "aria-disabled": e.disabled,
      ref_key: "elRef",
      ref: a
    }, [
      ae("div", {
        class: ye(["dp__inner_nav", { dp__inner_nav_disabled: e.disabled }])
      }, [
        K(t.$slots, "default")
      ], 2)
    ], 40, Mr));
  }
}), Tr = ["onKeydown"], Ar = { class: "dp__selection_grid_header" }, Sr = ["aria-selected", "aria-disabled", "data-test", "onClick", "onKeydown", "onMouseover"], Cr = ["aria-label", "onKeydown"], Dt = /* @__PURE__ */ We({
  __name: "SelectionGrid",
  props: {
    items: { type: Array, default: () => [] },
    modelValue: { type: [String, Number], default: null },
    multiModelValue: { type: Array, default: () => [] },
    disabledValues: { type: Array, default: () => [] },
    minValue: { type: [Number, String], default: null },
    maxValue: { type: [Number, String], default: null },
    year: { type: Number, default: 0 },
    skipActive: { type: Boolean, default: !1 },
    headerRefs: { type: Array, default: () => [] },
    skipButtonRef: { type: Boolean, default: !1 },
    monthPicker: { type: Boolean, default: !1 },
    yearPicker: { type: Boolean, default: !1 },
    escClose: { type: Boolean, default: !0 },
    type: { type: String, default: null },
    arrowNavigation: { type: Boolean, default: !1 },
    autoApply: { type: Boolean, default: !1 },
    textInput: { type: Boolean, default: !1 },
    ariaLabels: { type: Object, default: () => ({}) },
    hideNavigation: { type: Array, default: () => [] }
  },
  emits: ["update:model-value", "selected", "toggle", "reset-flow"],
  setup(e, { expose: n, emit: a }) {
    const t = e, { setSelectionGrid: s, buildMultiLevelMatrix: f, setMonthPicker: y } = nt(), { hideNavigationButtons: _ } = Ee(t), E = L(!1), T = L(null), U = L(null), A = L([]), c = L(), M = L(null), te = L(0), H = L(null);
    Jn(() => {
      T.value = null;
    }), He(() => {
      dt().then(() => N()), B(), z(!0);
    }), dn(() => z(!1));
    const z = (I) => {
      var l;
      t.arrowNavigation && ((l = t.headerRefs) != null && l.length ? y(I) : s(I));
    }, B = () => {
      const I = $e(U);
      I && (t.textInput || I.focus({ preventScroll: !0 }), E.value = I.clientHeight < I.scrollHeight);
    }, w = F(
      () => ({
        dp__overlay: !0
      })
    ), J = F(() => ({
      dp__overlay_col: !0
    })), ee = (I) => t.skipActive ? !1 : I.value === t.modelValue, x = F(() => t.items.map((I) => I.filter((l) => l).map((l) => {
      var r, k, Y;
      const o = t.disabledValues.some((R) => R === l.value) || C(l.value), g = (r = t.multiModelValue) != null && r.length ? (k = t.multiModelValue) == null ? void 0 : k.some(
        (R) => ve(
          R,
          ut(
            t.monthPicker ? Ot(/* @__PURE__ */ new Date(), l.value) : /* @__PURE__ */ new Date(),
            t.monthPicker ? t.year : l.value
          )
        )
      ) : ee(l);
      return {
        ...l,
        className: {
          dp__overlay_cell_active: g,
          dp__overlay_cell: !g,
          dp__overlay_cell_disabled: o,
          dp__overlay_cell_active_disabled: o && g,
          dp__overlay_cell_pad: !0,
          dp__cell_in_between: (Y = t.multiModelValue) != null && Y.length && t.skipActive ? P(l.value) : !1
        }
      };
    }))), le = F(
      () => ({
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: E.value,
        dp__button_bottom: t.autoApply
      })
    ), de = F(() => {
      var I, l;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((I = t.items) == null ? void 0 : I.length) <= 6,
        dp__container_block: ((l = t.items) == null ? void 0 : l.length) > 6
      };
    }), C = (I) => {
      const l = t.maxValue || t.maxValue === 0, o = t.minValue || t.minValue === 0;
      return !l && !o ? !1 : l && o ? +I > +t.maxValue || +I < +t.minValue : l ? +I > +t.maxValue : o ? +I < +t.minValue : !1;
    }, N = () => {
      const I = $e(T), l = $e(U), o = $e(M), g = $e(H), r = o ? o.getBoundingClientRect().height : 0;
      l && (te.value = l.getBoundingClientRect().height - r), I && g && (g.scrollTop = I.offsetTop - g.offsetTop - (te.value / 2 - I.getBoundingClientRect().height) - r);
    }, G = (I) => {
      !t.disabledValues.some((l) => l === I) && !C(I) && (a("update:model-value", I), a("selected"));
    }, P = (I) => {
      const l = t.monthPicker ? t.year : I;
      return xn(
        t.multiModelValue,
        ut(
          t.monthPicker ? Ot(/* @__PURE__ */ new Date(), c.value || 0) : /* @__PURE__ */ new Date(),
          t.monthPicker ? l : c.value || l
        ),
        ut(t.monthPicker ? Ot(/* @__PURE__ */ new Date(), I) : /* @__PURE__ */ new Date(), l)
      );
    }, Z = () => {
      a("toggle"), a("reset-flow");
    }, p = () => {
      t.escClose && Z();
    }, q = (I, l, o, g) => {
      I && (l.value === +t.modelValue && !t.disabledValues.includes(l.value) && (T.value = I), t.arrowNavigation && (Array.isArray(A.value[o]) ? A.value[o][g] = I : A.value[o] = [I], j()));
    }, j = () => {
      var l, o;
      const I = (l = t.headerRefs) != null && l.length ? [t.headerRefs].concat(A.value) : A.value.concat([t.skipButtonRef ? [] : [M.value]]);
      f(Me(I), (o = t.headerRefs) != null && o.length ? "monthPicker" : "selectionGrid");
    };
    return n({ focusGrid: B }), (I, l) => {
      var o;
      return h(), O("div", {
        ref_key: "gridWrapRef",
        ref: U,
        class: ye(u(w)),
        role: "dialog",
        tabindex: "0",
        onKeydown: ue(p, ["esc"])
      }, [
        ae("div", {
          class: ye(u(de)),
          ref_key: "containerRef",
          ref: H,
          role: "grid",
          style: Qe({ height: `${te.value}px` })
        }, [
          ae("div", Ar, [
            K(I.$slots, "header")
          ]),
          I.$slots.overlay ? K(I.$slots, "overlay", { key: 0 }) : (h(!0), O(ce, { key: 1 }, De(u(x), (g, r) => (h(), O("div", {
            class: ye(["dp__overlay_row", { dp__flex_row: u(x).length >= 3 }]),
            key: r,
            role: "row"
          }, [
            (h(!0), O(ce, null, De(g, (k, Y) => (h(), O("div", {
              role: "gridcell",
              class: ye(u(J)),
              key: k.value,
              "aria-selected": k.value === e.modelValue && !e.disabledValues.includes(k.value),
              "aria-disabled": k.className.dp__overlay_cell_disabled,
              ref_for: !0,
              ref: (R) => q(R, k, r, Y),
              tabindex: "0",
              "data-test": k.text,
              onClick: (R) => G(k.value),
              onKeydown: [
                ue((R) => G(k.value), ["enter"]),
                ue((R) => G(k.value), ["space"])
              ],
              onMouseover: (R) => c.value = k.value
            }, [
              ae("div", {
                class: ye(k.className)
              }, [
                I.$slots.item ? K(I.$slots, "item", {
                  key: 0,
                  item: k
                }) : S("", !0),
                I.$slots.item ? S("", !0) : (h(), O(ce, { key: 1 }, [
                  ze(Ce(k.text), 1)
                ], 64))
              ], 2)
            ], 42, Sr))), 128))
          ], 2))), 128))
        ], 6),
        I.$slots["button-icon"] ? _t((h(), O("div", {
          key: 0,
          role: "button",
          "aria-label": (o = e.ariaLabels) == null ? void 0 : o.toggleOverlay,
          class: ye(u(le)),
          tabindex: "0",
          ref_key: "toggleButton",
          ref: M,
          onClick: Z,
          onKeydown: ue(Z, ["enter"])
        }, [
          K(I.$slots, "button-icon")
        ], 42, Cr)), [
          [Nt, !u(_)(e.type)]
        ]) : S("", !0)
      ], 42, Tr);
    };
  }
}), Pr = ["aria-label"], Bn = /* @__PURE__ */ We({
  __name: "RegularPicker",
  props: {
    ariaLabel: { type: String, default: "" },
    showSelectionGrid: { type: Boolean, default: !1 },
    modelValue: { type: Number, default: null },
    items: { type: Array, default: () => [] },
    disabledValues: { type: Array, default: () => [] },
    minValue: { type: Number, default: null },
    maxValue: { type: Number, default: null },
    slotName: { type: String, default: "" },
    overlaySlot: { type: String, default: "" },
    headerRefs: { type: Array, default: () => [] },
    escClose: { type: Boolean, default: !0 },
    type: { type: String, default: null },
    transitions: { type: [Object, Boolean], default: !1 },
    arrowNavigation: { type: Boolean, default: !1 },
    autoApply: { type: Boolean, default: !1 },
    textInput: { type: Boolean, default: !1 },
    ariaLabels: { type: Object, default: () => ({}) },
    hideNavigation: { type: Array, default: () => [] }
  },
  emits: ["update:model-value", "toggle", "set-ref"],
  setup(e, { emit: n }) {
    const a = e, { transitionName: t, showTransition: s } = Ut(a.transitions), f = L(null);
    return He(() => n("set-ref", f)), (y, _) => (h(), O(ce, null, [
      ae("div", {
        class: "dp__month_year_select",
        onClick: _[0] || (_[0] = (E) => y.$emit("toggle")),
        onKeydown: [
          _[1] || (_[1] = ue((E) => y.$emit("toggle"), ["enter"])),
          _[2] || (_[2] = ue((E) => y.$emit("toggle"), ["space"]))
        ],
        role: "button",
        "aria-label": e.ariaLabel,
        tabindex: "0",
        ref_key: "elRef",
        ref: f
      }, [
        K(y.$slots, "default")
      ], 40, Pr),
      et(gt, {
        name: u(t)(e.showSelectionGrid),
        css: u(s)
      }, {
        default: oe(() => [
          e.showSelectionGrid ? (h(), fe(Dt, Te({ key: 0 }, {
            modelValue: e.modelValue,
            items: e.items,
            disabledValues: e.disabledValues,
            minValue: e.minValue,
            maxValue: e.maxValue,
            escClose: e.escClose,
            type: e.type,
            arrowNavigation: e.arrowNavigation,
            textInput: e.textInput,
            autoApply: e.autoApply,
            ariaLabels: e.ariaLabels,
            hideNavigation: e.hideNavigation
          }, {
            "header-refs": [],
            "onUpdate:modelValue": _[3] || (_[3] = (E) => y.$emit("update:model-value", E)),
            onToggle: _[4] || (_[4] = (E) => y.$emit("toggle"))
          }), Ve({
            "button-icon": oe(() => [
              y.$slots["calendar-icon"] ? K(y.$slots, "calendar-icon", { key: 0 }) : S("", !0),
              y.$slots["calendar-icon"] ? S("", !0) : (h(), fe(u(Lt), { key: 1 }))
            ]),
            _: 2
          }, [
            y.$slots[e.slotName] ? {
              name: "item",
              fn: oe(({ item: E }) => [
                K(y.$slots, e.slotName, { item: E })
              ]),
              key: "0"
            } : void 0,
            y.$slots[e.overlaySlot] ? {
              name: "overlay",
              fn: oe(() => [
                K(y.$slots, e.overlaySlot)
              ]),
              key: "1"
            } : void 0,
            y.$slots[`${e.overlaySlot}-header`] ? {
              name: "header",
              fn: oe(() => [
                K(y.$slots, `${e.overlaySlot}-header`)
              ]),
              key: "2"
            } : void 0
          ]), 1040)) : S("", !0)
        ]),
        _: 3
      }, 8, ["name", "css"])
    ], 64));
  }
}), _r = { class: "dp__month_year_row" }, Nr = { class: "dp__month_year_wrap" }, Rr = { class: "dp__month_picker_header" }, Or = ["aria-label"], Ir = ["aria-label"], Br = ["aria-label"], Yr = /* @__PURE__ */ We({
  __name: "MonthYearPicker",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    internalModelValue: { type: [Date, Array], default: null },
    ...at
  },
  emits: ["update-month-year", "month-year-select", "mount", "reset-flow", "overlay-closed"],
  setup(e, { expose: n, emit: a }) {
    const t = e, { defaults: s } = Ee(t), { transitionName: f, showTransition: y } = Ut(s.value.transitions), { buildMatrix: _ } = nt(), { handleMonthYearChange: E, isDisabled: T, updateMonthYear: U } = tr(t, a), A = L(!1), c = L(!1), M = L([null, null, null, null]), te = L(null), H = L(null), z = L(null);
    He(() => {
      a("mount");
    });
    const B = (m) => ({
      get: () => t[m],
      set: (b) => {
        const v = m === "month" ? "year" : "month";
        a("update-month-year", { [m]: b, [v]: t[v] }), a("month-year-select", m === "year"), m === "month" ? g(!0) : r(!0);
      }
    }), w = F(B("month")), J = F(B("year")), ee = (m) => {
      const b = ke($(m));
      return t.year === b;
    }, x = F(() => t.monthPicker ? Array.isArray(t.disabledDates) ? t.disabledDates.map((m) => $(m)).filter((m) => ee(m)).map((m) => pe(m)) : [] : []), le = F(() => (m) => {
      const b = m === "month";
      return {
        showSelectionGrid: (b ? A : c).value,
        items: (b ? j : I).value,
        disabledValues: s.value.filters[b ? "months" : "years"].concat(x.value),
        minValue: (b ? G : C).value,
        maxValue: (b ? P : N).value,
        headerRefs: b && t.monthPicker ? [te.value, H.value, z.value] : [],
        escClose: t.escClose,
        transitions: s.value.transitions,
        ariaLabels: s.value.ariaLabels,
        textInput: t.textInput,
        autoApply: t.autoApply,
        arrowNavigation: t.arrowNavigation,
        hideNavigation: t.hideNavigation
      };
    }), de = F(() => (m) => ({
      month: t.month,
      year: t.year,
      items: m === "month" ? t.months : t.years,
      instance: t.instance,
      updateMonthYear: U,
      toggle: m === "month" ? g : r
    })), C = F(() => t.minDate ? ke($(t.minDate)) : null), N = F(() => t.maxDate ? ke($(t.maxDate)) : null), G = F(() => {
      if (t.minDate && C.value) {
        if (C.value > t.year)
          return 12;
        if (C.value === t.year)
          return pe($(t.minDate));
      }
      return null;
    }), P = F(() => t.maxDate && N.value ? N.value < t.year ? -1 : N.value === t.year ? pe($(t.maxDate)) : null : null), Z = F(() => (t.range || t.multiDates) && t.internalModelValue && (t.monthPicker || t.yearPicker) ? t.internalModelValue : []), p = (m) => {
      const b = [], v = (W) => W;
      for (let W = 0; W < m.length; W += 3) {
        const se = [m[W], m[W + 1], m[W + 2]];
        b.push(v(se));
      }
      return b;
    }, q = F(() => {
      const m = t.months.find((b) => b.value === t.month);
      return m || { text: "", value: 0 };
    }), j = F(() => p(t.months)), I = F(() => p(t.years)), l = F(() => s.value.multiCalendars ? t.multiCalendarsSolo ? !0 : t.instance === 0 : !0), o = F(() => s.value.multiCalendars ? t.multiCalendarsSolo ? !0 : t.instance === s.value.multiCalendars - 1 : !0), g = (m = !1) => {
      k(m), A.value = !A.value, A.value || a("overlay-closed");
    }, r = (m = !1) => {
      k(m), c.value = !c.value, c.value || a("overlay-closed");
    }, k = (m) => {
      m || a("reset-flow");
    }, Y = (m = !1) => {
      T.value(m) || a("update-month-year", {
        year: m ? t.year + 1 : t.year - 1,
        month: t.month,
        fromNav: !0
      });
    }, R = (m, b) => {
      t.arrowNavigation && (M.value[b] = $e(m), _(M.value, "monthYear"));
    };
    return n({
      toggleMonthPicker: g,
      toggleYearPicker: r,
      handleMonthYearChange: E
    }), (m, b) => {
      var v, W, se, Ne, Xe;
      return h(), O("div", _r, [
        m.$slots["month-year"] ? K(m.$slots, "month-year", Pe(Te({ key: 0 }, { month: e.month, year: e.year, months: e.months, years: e.years, updateMonthYear: u(U), handleMonthYearChange: u(E), instance: e.instance }))) : (h(), O(ce, { key: 1 }, [
          !m.monthPicker && !m.yearPicker ? (h(), O(ce, { key: 0 }, [
            u(l) && !m.vertical ? (h(), fe(rn, {
              key: 0,
              "aria-label": (v = u(s).ariaLabels) == null ? void 0 : v.prevMonth,
              disabled: u(T)(!1),
              onActivate: b[0] || (b[0] = (re) => u(E)(!1)),
              onSetRef: b[1] || (b[1] = (re) => R(re, 0))
            }, {
              default: oe(() => [
                m.$slots["arrow-left"] ? K(m.$slots, "arrow-left", { key: 0 }) : S("", !0),
                m.$slots["arrow-left"] ? S("", !0) : (h(), fe(u(wn), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled"])) : S("", !0),
            ae("div", Nr, [
              et(Bn, Te({
                type: "month",
                "slot-name": "month-overlay-val",
                "overlay-slot": "overlay-month",
                "aria-label": (W = u(s).ariaLabels) == null ? void 0 : W.openMonthsOverlay,
                modelValue: u(w),
                "onUpdate:modelValue": b[2] || (b[2] = (re) => ot(w) ? w.value = re : null)
              }, u(le)("month"), {
                onToggle: g,
                onSetRef: b[3] || (b[3] = (re) => R(re, 1))
              }), Ve({
                default: oe(() => [
                  m.$slots.month ? K(m.$slots, "month", Pe(Te({ key: 0 }, u(q)))) : S("", !0),
                  m.$slots.month ? S("", !0) : (h(), O(ce, { key: 1 }, [
                    ze(Ce(u(q).text), 1)
                  ], 64))
                ]),
                _: 2
              }, [
                m.$slots["calendar-icon"] ? {
                  name: "calendar-icon",
                  fn: oe(() => [
                    K(m.$slots, "calendar-icon")
                  ]),
                  key: "0"
                } : void 0,
                m.$slots["month-overlay-value"] ? {
                  name: "month-overlay-val",
                  fn: oe(({ item: re }) => [
                    K(m.$slots, "month-overlay-value", {
                      text: re.text,
                      value: re.value
                    })
                  ]),
                  key: "1"
                } : void 0,
                m.$slots["month-overlay"] ? {
                  name: "overlay-month",
                  fn: oe(() => [
                    K(m.$slots, "month-overlay", Pe(Le(u(de)("month"))))
                  ]),
                  key: "2"
                } : void 0,
                m.$slots["month-overlay-header"] ? {
                  name: "overlay-month-header",
                  fn: oe(() => [
                    K(m.$slots, "month-overlay-header", { toggle: g })
                  ]),
                  key: "3"
                } : void 0
              ]), 1040, ["aria-label", "modelValue"]),
              et(Bn, Te({
                type: "year",
                "slot-name": "year-overlay-val",
                "overlay-slot": "overlay-year",
                "aria-label": (se = u(s).ariaLabels) == null ? void 0 : se.openYearsOverlay,
                modelValue: u(J),
                "onUpdate:modelValue": b[4] || (b[4] = (re) => ot(J) ? J.value = re : null)
              }, u(le)("year"), {
                onToggle: r,
                onSetRef: b[5] || (b[5] = (re) => R(re, 2))
              }), Ve({
                default: oe(() => [
                  m.$slots.year ? K(m.$slots, "year", {
                    key: 0,
                    year: e.year
                  }) : S("", !0),
                  m.$slots.year ? S("", !0) : (h(), O(ce, { key: 1 }, [
                    ze(Ce(e.year), 1)
                  ], 64))
                ]),
                _: 2
              }, [
                m.$slots["calendar-icon"] ? {
                  name: "calendar-icon",
                  fn: oe(() => [
                    K(m.$slots, "calendar-icon")
                  ]),
                  key: "0"
                } : void 0,
                m.$slots["year-overlay-value"] ? {
                  name: "year-overlay-val",
                  fn: oe(({ item: re }) => [
                    K(m.$slots, "year-overlay-value", {
                      text: re.text,
                      value: re.value
                    })
                  ]),
                  key: "1"
                } : void 0,
                m.$slots["year-overlay"] ? {
                  name: "overlay-year",
                  fn: oe(() => [
                    K(m.$slots, "year-overlay", Pe(Le(u(de)("year"))))
                  ]),
                  key: "2"
                } : void 0,
                m.$slots["year-overlay-header"] ? {
                  name: "overlay-year-header",
                  fn: oe(() => [
                    K(m.$slots, "year-overlay-header", { toggle: r })
                  ]),
                  key: "3"
                } : void 0
              ]), 1040, ["aria-label", "modelValue"])
            ]),
            u(l) && m.vertical ? (h(), fe(rn, {
              key: 1,
              "aria-label": (Ne = u(s).ariaLabels) == null ? void 0 : Ne.prevMonth,
              disabled: u(T)(!1),
              onActivate: b[6] || (b[6] = (re) => u(E)(!1))
            }, {
              default: oe(() => [
                m.$slots["arrow-up"] ? K(m.$slots, "arrow-up", { key: 0 }) : S("", !0),
                m.$slots["arrow-up"] ? S("", !0) : (h(), fe(u(Wn), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled"])) : S("", !0),
            u(o) ? (h(), fe(rn, {
              key: 2,
              ref: "rightIcon",
              disabled: u(T)(!0),
              "aria-label": (Xe = u(s).ariaLabels) == null ? void 0 : Xe.nextMonth,
              onActivate: b[7] || (b[7] = (re) => u(E)(!0)),
              onSetRef: b[8] || (b[8] = (re) => R(re, 3))
            }, {
              default: oe(() => [
                m.$slots[m.vertical ? "arrow-down" : "arrow-right"] ? K(m.$slots, m.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : S("", !0),
                m.$slots[m.vertical ? "arrow-down" : "arrow-right"] ? S("", !0) : (h(), fe(Yn(m.vertical ? u(zn) : u(bn)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label"])) : S("", !0)
          ], 64)) : S("", !0),
          m.monthPicker ? (h(), fe(Dt, Te({ key: 1 }, u(le)("month"), {
            "skip-active": m.range,
            year: e.year,
            "multi-model-value": u(Z),
            "month-picker": "",
            modelValue: u(w),
            "onUpdate:modelValue": b[17] || (b[17] = (re) => ot(w) ? w.value = re : null),
            onToggle: g,
            onSelected: b[18] || (b[18] = (re) => m.$emit("overlay-closed"))
          }), Ve({
            header: oe(() => {
              var re, qe, xe;
              return [
                ae("div", Rr, [
                  ae("div", {
                    class: "dp__month_year_col_nav",
                    tabindex: "0",
                    ref_key: "mpPrevIconRef",
                    ref: te,
                    onClick: b[9] || (b[9] = (Re) => Y(!1)),
                    onKeydown: b[10] || (b[10] = ue((Re) => Y(!1), ["enter"]))
                  }, [
                    ae("div", {
                      class: ye(["dp__inner_nav", { dp__inner_nav_disabled: u(T)(!1) }]),
                      role: "button",
                      "aria-label": (re = u(s).ariaLabels) == null ? void 0 : re.prevMonth
                    }, [
                      m.$slots["arrow-left"] ? K(m.$slots, "arrow-left", { key: 0 }) : S("", !0),
                      m.$slots["arrow-left"] ? S("", !0) : (h(), fe(u(wn), { key: 1 }))
                    ], 10, Or)
                  ], 544),
                  ae("div", {
                    class: "dp__pointer",
                    role: "button",
                    ref_key: "mpYearButtonRef",
                    ref: H,
                    "aria-label": (qe = u(s).ariaLabels) == null ? void 0 : qe.openYearsOverlay,
                    tabindex: "0",
                    onClick: b[11] || (b[11] = () => r(!1)),
                    onKeydown: b[12] || (b[12] = ue(() => r(!1), ["enter"]))
                  }, [
                    m.$slots.year ? K(m.$slots, "year", {
                      key: 0,
                      year: e.year
                    }) : S("", !0),
                    m.$slots.year ? S("", !0) : (h(), O(ce, { key: 1 }, [
                      ze(Ce(e.year), 1)
                    ], 64))
                  ], 40, Ir),
                  ae("div", {
                    class: "dp__month_year_col_nav",
                    tabindex: "0",
                    ref_key: "mpNextIconRef",
                    ref: z,
                    onClick: b[13] || (b[13] = (Re) => Y(!0)),
                    onKeydown: b[14] || (b[14] = ue((Re) => Y(!0), ["enter"]))
                  }, [
                    ae("div", {
                      class: ye(["dp__inner_nav", { dp__inner_nav_disabled: u(T)(!0) }]),
                      role: "button",
                      "aria-label": (xe = u(s).ariaLabels) == null ? void 0 : xe.nextMonth
                    }, [
                      m.$slots["arrow-right"] ? K(m.$slots, "arrow-right", { key: 0 }) : S("", !0),
                      m.$slots["arrow-right"] ? S("", !0) : (h(), fe(u(bn), { key: 1 }))
                    ], 10, Br)
                  ], 544)
                ]),
                et(gt, {
                  name: u(f)(c.value),
                  css: u(y)
                }, {
                  default: oe(() => [
                    c.value ? (h(), fe(Dt, Te({ key: 0 }, u(le)("year"), {
                      modelValue: u(J),
                      "onUpdate:modelValue": b[15] || (b[15] = (Re) => ot(J) ? J.value = Re : null),
                      onToggle: r,
                      onSelected: b[16] || (b[16] = (Re) => m.$emit("overlay-closed"))
                    }), Ve({
                      "button-icon": oe(() => [
                        m.$slots["calendar-icon"] ? K(m.$slots, "calendar-icon", { key: 0 }) : S("", !0),
                        m.$slots["calendar-icon"] ? S("", !0) : (h(), fe(u(Lt), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      m.$slots["year-overlay-value"] ? {
                        name: "item",
                        fn: oe(({ item: Re }) => [
                          K(m.$slots, "year-overlay-value", {
                            text: Re.text,
                            value: Re.value
                          })
                        ]),
                        key: "0"
                      } : void 0
                    ]), 1040, ["modelValue"])) : S("", !0)
                  ]),
                  _: 3
                }, 8, ["name", "css"])
              ];
            }),
            _: 2
          }, [
            m.$slots["month-overlay-value"] ? {
              name: "item",
              fn: oe(({ item: re }) => [
                K(m.$slots, "month-overlay-value", {
                  text: re.text,
                  value: re.value
                })
              ]),
              key: "0"
            } : void 0
          ]), 1040, ["skip-active", "year", "multi-model-value", "modelValue"])) : S("", !0),
          m.yearPicker ? (h(), fe(Dt, Te({ key: 2 }, u(le)("year"), {
            modelValue: u(J),
            "onUpdate:modelValue": b[19] || (b[19] = (re) => ot(J) ? J.value = re : null),
            "multi-model-value": u(Z),
            "skip-active": m.range,
            "skip-button-ref": "",
            "year-picker": "",
            onToggle: r,
            onSelected: b[20] || (b[20] = (re) => m.$emit("overlay-closed"))
          }), Ve({ _: 2 }, [
            m.$slots["year-overlay-value"] ? {
              name: "item",
              fn: oe(({ item: re }) => [
                K(m.$slots, "year-overlay-value", {
                  text: re.text,
                  value: re.value
                })
              ]),
              key: "0"
            } : void 0
          ]), 1040, ["modelValue", "multi-model-value", "skip-active"])) : S("", !0)
        ], 64))
      ]);
    };
  }
}), Vr = {
  key: 0,
  class: "dp__time_input"
}, Er = ["aria-label", "onKeydown", "onClick"], Fr = ["aria-label", "data-test", "onKeydown", "onClick"], Lr = ["aria-label", "onKeydown", "onClick"], Ur = { key: 0 }, Hr = ["aria-label", "onKeydown"], Wr = /* @__PURE__ */ We({
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    ...at
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed"
  ],
  setup(e, { expose: n, emit: a }) {
    const t = e, { setTimePickerElements: s, setTimePickerBackRef: f } = nt(), { defaults: y } = Ee(t), { transitionName: _, showTransition: E } = Ut(y.value.transitions), T = Mt({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), U = L("AM"), A = L(null), c = L([]);
    He(() => {
      a("mounted");
    });
    const M = F(() => (l) => !!(t.maxTime && t.maxTime[l] && +t.maxTime[l] < +t[l] + +t[`${l}Increment`])), te = F(() => (l) => !!(t.minTime && t.minTime[l] && +t.minTime[l] > +t[l] - +t[`${l}Increment`])), H = (l, o) => Un(Se($(), l), o), z = (l, o) => ca(Se($(), l), o), B = F(
      () => ({
        dp__time_col: !0,
        dp__time_col_reg: !t.enableSeconds && t.is24,
        dp__time_col_reg_with_button: !t.enableSeconds && !t.is24,
        dp__time_col_sec: t.enableSeconds && t.is24,
        dp__time_col_sec_with_button: t.enableSeconds && !t.is24
      })
    ), w = F(() => {
      const l = [{ type: "hours" }, { type: "", separator: !0 }, { type: "minutes" }];
      return t.enableSeconds ? l.concat([{ type: "", separator: !0 }, { type: "seconds" }]) : l;
    }), J = F(() => w.value.filter((l) => !l.separator)), ee = F(() => (l) => {
      if (l === "hours") {
        const o = Z(+t.hours);
        return { text: o < 10 ? `0${o}` : `${o}`, value: o };
      }
      return { text: t[l] < 10 ? `0${t[l]}` : `${t[l]}`, value: t[l] };
    }), x = (l) => {
      const o = t.is24 ? 24 : 12, g = l === "hours" ? o : 60, r = +t[`${l}GridIncrement`], k = l === "hours" && !t.is24 ? r : 0, Y = [];
      for (let R = k; R < g; R += r)
        Y.push({ value: R, text: R < 10 ? `0${R}` : `${R}` });
      return l === "hours" && !t.is24 && Y.push({ value: 0, text: "12" }), Ua(Y);
    }, le = (l, o) => {
      const g = t.minTime && t.minTime[o], r = t.maxTime && t.maxTime[o];
      return g && r ? l < +g || l > +r : g ? l < +g : r ? l > +r : !1;
    }, de = F(() => (l) => x(l).flat().filter((g) => g).map((g) => g.value).filter((g) => le(g, l))), C = (l) => t[`no${l[0].toUpperCase() + l.slice(1)}Overlay`], N = (l) => {
      C(l) || (T[l] = !T[l], T[l] || a("overlay-closed"));
    }, G = (l) => l === "hours" ? je : l === "minutes" ? Ge : yt, P = (l, o = !0) => {
      const g = o ? H : z;
      (o ? M.value(l) : te.value(l)) || a(
        `update:${l}`,
        G(l)(g({ [l]: +t[l] }, { [l]: +t[`${l}Increment`] }))
      );
    }, Z = (l) => t.is24 ? l : (l >= 12 ? U.value = "PM" : U.value = "AM", xa(l)), p = () => {
      U.value === "PM" ? (U.value = "AM", a("update:hours", t.hours - 12)) : (U.value = "PM", a("update:hours", t.hours + 12));
    }, q = (l) => {
      T[l] = !0;
    }, j = (l, o, g) => {
      if (l && t.arrowNavigation) {
        Array.isArray(c.value[o]) ? c.value[o][g] = l : c.value[o] = [l];
        const r = c.value.reduce(
          (k, Y) => Y.map((R, m) => [...k[m] || [], Y[m]]),
          []
        );
        f(t.closeTimePickerBtn), A.value && (r[1] = r[1].concat(A.value)), s(r, t.order);
      }
    }, I = (l, o) => l === "hours" && !t.is24 ? a(`update:${l}`, U.value === "PM" ? o + 12 : o) : a(`update:${l}`, o);
    return n({ openChildCmp: q }), (l, o) => {
      var g;
      return l.disabled ? S("", !0) : (h(), O("div", Vr, [
        (h(!0), O(ce, null, De(u(w), (r, k) => {
          var Y, R, m;
          return h(), O("div", {
            key: k,
            class: ye(u(B))
          }, [
            r.separator ? (h(), O(ce, { key: 0 }, [
              ze(" : ")
            ], 64)) : (h(), O(ce, { key: 1 }, [
              ae("div", {
                class: ye({
                  dp__inc_dec_button: !0,
                  dp__inc_dec_button_disabled: u(M)(r.type)
                }),
                role: "button",
                "data-test": "time-inc-btn",
                "aria-label": (Y = u(y).ariaLabels) == null ? void 0 : Y.incrementValue(r.type),
                tabindex: "0",
                onKeydown: [
                  ue((b) => P(r.type), ["enter"]),
                  ue((b) => P(r.type), ["space"])
                ],
                onClick: (b) => P(r.type),
                ref_for: !0,
                ref: (b) => j(b, k, 0)
              }, [
                l.$slots["arrow-up"] ? K(l.$slots, "arrow-up", { key: 0 }) : S("", !0),
                l.$slots["arrow-up"] ? S("", !0) : (h(), fe(u(Wn), { key: 1 }))
              ], 42, Er),
              ae("div", {
                role: "button",
                "aria-label": (R = u(y).ariaLabels) == null ? void 0 : R.openTpOverlay(r.type),
                class: ye(C(r.type) ? "" : "dp__time_display"),
                tabindex: "0",
                "data-test": `${r.type}-toggle-overlay-btn`,
                onKeydown: [
                  ue((b) => N(r.type), ["enter"]),
                  ue((b) => N(r.type), ["space"])
                ],
                onClick: (b) => N(r.type),
                ref_for: !0,
                ref: (b) => j(b, k, 1)
              }, [
                l.$slots[r.type] ? K(l.$slots, r.type, {
                  key: 0,
                  text: u(ee)(r.type).text,
                  value: u(ee)(r.type).value
                }) : S("", !0),
                l.$slots[r.type] ? S("", !0) : (h(), O(ce, { key: 1 }, [
                  ze(Ce(u(ee)(r.type).text), 1)
                ], 64))
              ], 42, Fr),
              ae("div", {
                class: ye({
                  dp__inc_dec_button: !0,
                  dp__inc_dec_button_disabled: u(te)(r.type)
                }),
                role: "button",
                "data-test": "time-dec-btn",
                "aria-label": (m = u(y).ariaLabels) == null ? void 0 : m.decrementValue(r.type),
                tabindex: "0",
                onKeydown: [
                  ue((b) => P(r.type, !1), ["enter"]),
                  ue((b) => P(r.type, !1), ["space"])
                ],
                onClick: (b) => P(r.type, !1),
                ref_for: !0,
                ref: (b) => j(b, k, 2)
              }, [
                l.$slots["arrow-down"] ? K(l.$slots, "arrow-down", { key: 0 }) : S("", !0),
                l.$slots["arrow-down"] ? S("", !0) : (h(), fe(u(zn), { key: 1 }))
              ], 42, Lr)
            ], 64))
          ], 2);
        }), 128)),
        l.is24 ? S("", !0) : (h(), O("div", Ur, [
          l.$slots["am-pm-button"] ? K(l.$slots, "am-pm-button", {
            key: 0,
            toggle: p,
            value: U.value
          }) : S("", !0),
          l.$slots["am-pm-button"] ? S("", !0) : (h(), O("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: A,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (g = u(y).ariaLabels) == null ? void 0 : g.amPmButton,
            tabindex: "0",
            onClick: p,
            onKeydown: [
              ue(Ze(p, ["prevent"]), ["enter"]),
              ue(Ze(p, ["prevent"]), ["space"])
            ]
          }, Ce(U.value), 41, Hr))
        ])),
        (h(!0), O(ce, null, De(u(J), (r, k) => (h(), fe(gt, {
          key: k,
          name: u(_)(T[r.type]),
          css: u(E)
        }, {
          default: oe(() => [
            T[r.type] ? (h(), fe(Dt, {
              key: 0,
              items: x(r.type),
              "disabled-values": u(y).filters.times[r.type].concat(u(de)(r.type)),
              "esc-close": l.escClose,
              "aria-labels": u(y).ariaLabels,
              "hide-navigation": l.hideNavigation,
              "onUpdate:modelValue": (Y) => I(r.type, Y),
              onSelected: (Y) => N(r.type),
              onToggle: (Y) => N(r.type),
              onResetFlow: o[0] || (o[0] = (Y) => l.$emit("reset-flow")),
              type: r.type
            }, Ve({
              "button-icon": oe(() => [
                l.$slots["clock-icon"] ? K(l.$slots, "clock-icon", { key: 0 }) : S("", !0),
                l.$slots["clock-icon"] ? S("", !0) : (h(), fe(u(Hn), { key: 1 }))
              ]),
              _: 2
            }, [
              l.$slots[`${r.type}-overlay-value`] ? {
                name: "item",
                fn: oe(({ item: Y }) => [
                  K(l.$slots, `${r.type}-overlay-value`, {
                    text: Y.text,
                    value: Y.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "disabled-values", "esc-close", "aria-labels", "hide-navigation", "onUpdate:modelValue", "onSelected", "onToggle", "type"])) : S("", !0)
          ]),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), zr = ["aria-label"], xr = { class: "dp__overlay_container dp__container_flex dp__time_picker_overlay_container" }, Kr = {
  key: 1,
  class: "dp__overlay_row dp__flex_row"
}, jr = ["aria-label"], Gr = /* @__PURE__ */ We({
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    internalModelValue: { type: [Date, Array], default: null },
    ...at
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed"
  ],
  setup(e, { expose: n, emit: a }) {
    const t = e, { buildMatrix: s, setTimePicker: f } = nt(), y = cn(), { hideNavigationButtons: _, defaults: E } = Ee(t), { transitionName: T, showTransition: U } = Ut(E.value.transitions), A = L(null), c = L(null), M = L([]), te = L(null);
    He(() => {
      a("mount"), !t.timePicker && t.arrowNavigation ? s([$e(A.value)], "time") : f(!0, t.timePicker);
    });
    const H = F(() => t.range && t.modelAuto ? Zn(t.internalModelValue) : !0), z = L(!1), B = (P) => ({
      hours: Array.isArray(t.hours) ? t.hours[P] : t.hours,
      minutes: Array.isArray(t.minutes) ? t.minutes[P] : t.minutes,
      seconds: Array.isArray(t.seconds) ? t.seconds[P] : t.seconds
    }), w = F(() => {
      const P = [];
      if (t.range)
        for (let Z = 0; Z < 2; Z++)
          P.push(B(Z));
      else
        P.push(B(0));
      return P;
    }), J = (P, Z = !1, p = "") => {
      Z || a("reset-flow"), z.value = P, P && a("overlay-opened"), t.arrowNavigation && (f(P), P || a("overlay-closed")), dt(() => {
        p !== "" && M.value[0] && M.value[0].openChildCmp(p);
      });
    }, ee = F(() => ({
      dp__button: !0,
      dp__button_bottom: t.autoApply
    })), x = it(y, "timePicker"), le = (P, Z, p) => t.range ? Z === 0 ? [P, w.value[1][p]] : [w.value[0][p], P] : P, de = (P) => {
      a("update:hours", P);
    }, C = (P) => {
      a("update:minutes", P);
    }, N = (P) => {
      a("update:seconds", P);
    }, G = () => {
      te.value && t.arrowNavigation && te.value.focus({ preventScroll: !0 });
    };
    return n({ toggleTimePicker: J }), (P, Z) => {
      var p;
      return h(), O("div", null, [
        P.timePicker ? S("", !0) : _t((h(), O("div", {
          key: 0,
          class: ye(u(ee)),
          role: "button",
          "aria-label": (p = u(E).ariaLabels) == null ? void 0 : p.openTimePicker,
          tabindex: "0",
          "data-test": "open-time-picker-btn",
          ref_key: "openTimePickerBtn",
          ref: A,
          onKeydown: [
            Z[0] || (Z[0] = ue((q) => J(!0), ["enter"])),
            Z[1] || (Z[1] = ue((q) => J(!0), ["space"]))
          ],
          onClick: Z[2] || (Z[2] = (q) => J(!0))
        }, [
          P.$slots["clock-icon"] ? K(P.$slots, "clock-icon", { key: 0 }) : S("", !0),
          P.$slots["clock-icon"] ? S("", !0) : (h(), fe(u(Hn), { key: 1 }))
        ], 42, zr)), [
          [Nt, !u(_)("time")]
        ]),
        et(gt, {
          name: u(T)(z.value),
          css: u(U)
        }, {
          default: oe(() => {
            var q;
            return [
              z.value || P.timePicker ? (h(), O("div", {
                key: 0,
                class: "dp__overlay",
                ref_key: "overlayRef",
                ref: te,
                tabindex: "0"
              }, [
                ae("div", xr, [
                  P.$slots["time-picker-overlay"] ? K(P.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: de,
                    setMinutes: C,
                    setSeconds: N
                  }) : S("", !0),
                  P.$slots["time-picker-overlay"] ? S("", !0) : (h(), O("div", Kr, [
                    (h(!0), O(ce, null, De(u(w), (j, I) => _t((h(), fe(Wr, Te({ key: I }, {
                      ...P.$props,
                      order: I,
                      hours: j.hours,
                      minutes: j.minutes,
                      seconds: j.seconds,
                      closeTimePickerBtn: c.value,
                      disabled: I === 0 ? P.fixedStart : P.fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: M,
                      "onUpdate:hours": (l) => de(le(l, I, "hours")),
                      "onUpdate:minutes": (l) => C(le(l, I, "minutes")),
                      "onUpdate:seconds": (l) => N(le(l, I, "seconds")),
                      onMounted: G,
                      onOverlayClosed: G
                    }), Ve({ _: 2 }, [
                      De(u(x), (l, o) => ({
                        name: l,
                        fn: oe((g) => [
                          K(P.$slots, l, Pe(Le(g)))
                        ])
                      }))
                    ]), 1040, ["onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [Nt, I === 0 ? !0 : u(H)]
                    ])), 128))
                  ])),
                  P.timePicker ? S("", !0) : _t((h(), O("div", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: c,
                    class: ye(u(ee)),
                    role: "button",
                    "aria-label": (q = u(E).ariaLabels) == null ? void 0 : q.closeTimePicker,
                    tabindex: "0",
                    onKeydown: [
                      Z[3] || (Z[3] = ue((j) => J(!1), ["enter"])),
                      Z[4] || (Z[4] = ue((j) => J(!1), ["space"]))
                    ],
                    onClick: Z[5] || (Z[5] = (j) => J(!1))
                  }, [
                    P.$slots["calendar-icon"] ? K(P.$slots, "calendar-icon", { key: 0 }) : S("", !0),
                    P.$slots["calendar-icon"] ? S("", !0) : (h(), fe(u(Lt), { key: 1 }))
                  ], 42, jr)), [
                    [Nt, !u(_)("time")]
                  ])
                ])
              ], 512)) : S("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), Zr = (e, n) => {
  const { isDisabled: a, matchDate: t, getWeekFromDate: s, defaults: f } = Ee(n), y = L(null), _ = L($()), E = (r) => {
    !r.current && n.hideOffsetDates || (y.value = r.value);
  }, T = () => {
    y.value = null;
  }, U = (r) => Array.isArray(e.value) && n.range && e.value[0] && y.value ? r ? Be(y.value, e.value[0]) : _e(y.value, e.value[0]) : !0, A = (r, k) => {
    const Y = () => e.value ? k ? e.value[0] || null : e.value[1] : null, R = e.value && Array.isArray(e.value) ? Y() : null;
    return ve($(r.value), R);
  }, c = (r) => {
    const k = Array.isArray(e.value) ? e.value[0] : null;
    return r ? !_e(y.value || null, k) : !0;
  }, M = (r, k = !0) => (n.range || n.weekPicker) && Array.isArray(e.value) ? n.hideOffsetDates && !r.current ? !1 : ve($(r.value), e.value[k ? 0 : 1]) : n.range ? A(r, k) && c(k) || ve(r.value, Array.isArray(e.value) ? e.value[0] : null) && U(k) : !1, te = (r, k, Y) => Array.isArray(e.value) && e.value[0] && e.value.length === 1 ? r ? !1 : Y ? Be(e.value[0], k.value) : _e(e.value[0], k.value) : !1, H = (r) => !e.value || n.hideOffsetDates && !r.current ? !1 : n.range ? n.modelAuto && Array.isArray(e.value) ? ve(r.value, e.value[0] ? e.value[0] : _.value) : !1 : n.multiDates && Array.isArray(e.value) ? e.value.some((k) => ve(k, r.value)) : ve(r.value, e.value ? e.value : _.value), z = (r) => {
    if (n.autoRange || n.weekPicker) {
      if (y.value) {
        if (n.hideOffsetDates && !r.current)
          return !1;
        const k = mt(y.value, +n.autoRange), Y = s($(y.value));
        return n.weekPicker ? ve(Y[1], $(r.value)) : ve(k, $(r.value));
      }
      return !1;
    }
    return !1;
  }, B = (r) => {
    if (n.autoRange || n.weekPicker) {
      if (y.value) {
        const k = mt(y.value, +n.autoRange);
        if (n.hideOffsetDates && !r.current)
          return !1;
        const Y = s($(y.value));
        return n.weekPicker ? Be(r.value, Y[0]) && _e(r.value, Y[1]) : Be(r.value, y.value) && _e(r.value, k);
      }
      return !1;
    }
    return !1;
  }, w = (r) => {
    if (n.autoRange || n.weekPicker) {
      if (y.value) {
        if (n.hideOffsetDates && !r.current)
          return !1;
        const k = s($(y.value));
        return n.weekPicker ? ve(k[0], r.value) : ve(y.value, r.value);
      }
      return !1;
    }
    return !1;
  }, J = (r) => xn(e.value, y.value, r.value), ee = () => n.modelAuto && Array.isArray(n.internalModelValue) ? !!n.internalModelValue[0] : !1, x = () => n.modelAuto ? Zn(n.internalModelValue) : !0, le = (r) => {
    if (Array.isArray(e.value) && e.value.length || n.weekPicker)
      return !1;
    const k = n.range ? !M(r) && !M(r, !1) : !0;
    return !a(r.value) && !H(r) && !(!r.current && n.hideOffsetDates) && k;
  }, de = (r) => n.range ? n.modelAuto ? ee() && H(r) : !1 : H(r), C = (r) => n.highlight ? t(r.value, n.highlight) : !1, N = (r) => a(r.value) && n.highlightDisabledDays === !1, G = (r) => n.highlightWeekDays && n.highlightWeekDays.includes(r.value.getDay()), P = (r) => (n.range || n.weekPicker) && (!(f.value.multiCalendars > 0) || r.current) && x() && !(!r.current && n.hideOffsetDates) && !H(r) ? J(r) : !1, Z = (r) => {
    const { isRangeStart: k, isRangeEnd: Y } = j(r), R = n.range ? k || Y : !1;
    return {
      dp__cell_offset: !r.current,
      dp__pointer: !n.disabled && !(!r.current && n.hideOffsetDates) && !a(r.value),
      dp__cell_disabled: a(r.value),
      dp__cell_highlight: !N(r) && (C(r) || G(r)) && !de(r) && !R,
      dp__cell_highlight_active: !N(r) && (C(r) || G(r)) && de(r),
      dp__today: !n.noToday && ve(r.value, _.value) && r.current
    };
  }, p = (r) => ({
    dp__active_date: de(r),
    dp__date_hover: le(r)
  }), q = (r) => ({
    ...I(r),
    ...l(r),
    dp__range_between_week: P(r) && n.weekPicker
  }), j = (r) => {
    const k = f.value.multiCalendars > 0 ? r.current && M(r) && x() : M(r) && x(), Y = f.value.multiCalendars > 0 ? r.current && M(r, !1) && x() : M(r, !1) && x();
    return { isRangeStart: k, isRangeEnd: Y };
  }, I = (r) => {
    const { isRangeStart: k, isRangeEnd: Y } = j(r);
    return {
      dp__range_start: k,
      dp__range_end: Y,
      dp__range_between: P(r) && !n.weekPicker,
      dp__date_hover_start: te(le(r), r, !0),
      dp__date_hover_end: te(le(r), r, !1)
    };
  }, l = (r) => ({
    ...I(r),
    dp__cell_auto_range: B(r),
    dp__cell_auto_range_start: w(r),
    dp__cell_auto_range_end: z(r)
  }), o = (r) => n.range ? n.autoRange ? l(r) : n.modelAuto ? { ...p(r), ...I(r) } : I(r) : n.weekPicker ? q(r) : p(r);
  return {
    setHoverDate: E,
    clearHoverDate: T,
    getDayClassData: (r) => ({
      ...Z(r),
      ...o(r),
      [n.dayClass ? n.dayClass(r.value) : ""]: !0,
      [n.calendarCellClassName]: !!n.calendarCellClassName
    })
  };
}, Xr = ["id", "onKeydown"], qr = {
  key: 0,
  class: "dp__sidebar_left"
}, Jr = {
  key: 1,
  class: "dp__preset_ranges"
}, Qr = ["onClick"], el = {
  key: 2,
  class: "dp__sidebar_right"
}, tl = {
  key: 3,
  class: "dp__now_wrap"
}, nl = /* @__PURE__ */ We({
  __name: "DatepickerMenu",
  props: {
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    ...at
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open"
  ],
  setup(e, { expose: n, emit: a }) {
    const t = e, { setMenuFocused: s, setShiftKey: f, control: y } = Kn(), { getCalendarDays: _, defaults: E } = Ee(t), T = cn(), U = L(null), A = Mt({
      timePicker: !!(!t.enableTimePicker || t.timePicker || t.monthPicker),
      monthYearInput: !!t.timePicker,
      calendar: !1
    }), c = L([]), M = L([]), te = L(null), H = L(null), z = L(0), B = L(!1), w = L(0);
    He(() => {
      var V;
      B.value = !0, !((V = t.presetRanges) != null && V.length) && !T["left-sidebar"] && !T["right-sidebar"] && (me(), window.addEventListener("resize", me));
      const d = $e(H);
      if (d && !t.textInput && !t.inline && (s(!0), C()), d) {
        const we = (be) => {
          ["action-row", "time-picker", "month-year"].some(
            (Ke) => Object.keys(T).includes(Ke)
          ) || be.preventDefault(), be.stopImmediatePropagation(), be.stopPropagation();
        };
        d.addEventListener("pointerdown", we), d.addEventListener("mousedown", we);
      }
    }), dn(() => {
      window.removeEventListener("resize", me);
    });
    const { arrowRight: J, arrowLeft: ee, arrowDown: x, arrowUp: le } = nt(), de = (d) => {
      d || d === 0 ? M.value[d].triggerTransition(
        p.value(d),
        q.value(d)
      ) : M.value.forEach(
        (V, we) => V.triggerTransition(p.value(we), q.value(we))
      );
    }, C = () => {
      const d = $e(H);
      d && d.focus({ preventScroll: !0 });
    }, N = () => {
      var d;
      (d = t.flow) != null && d.length && w.value !== -1 && (w.value += 1, a("flow-step", w.value), Gt());
    }, G = () => {
      w.value = -1;
    }, {
      calendars: P,
      modelValue: Z,
      month: p,
      year: q,
      time: j,
      updateTime: I,
      updateMonthYear: l,
      selectDate: o,
      getWeekNum: g,
      monthYearSelect: r,
      handleScroll: k,
      handleArrow: Y,
      handleSwipe: R,
      getMarker: m,
      selectCurrentDate: b,
      presetDateRange: v
    } = Qa(t, a, N, de, w), { setHoverDate: W, clearHoverDate: se, getDayClassData: Ne } = Zr(Z, t);
    tt(
      P,
      () => {
        t.openOnTop && setTimeout(() => {
          a("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    );
    const Xe = it(T, "calendar"), re = it(T, "action"), qe = it(T, "timePicker"), xe = it(T, "monthYear"), Re = F(() => t.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), rt = F(() => Wa(t.yearRange, t.reverseYears)), ne = F(() => za(t.locale, t.monthNameFormat)), me = () => {
      const d = $e(U);
      d && (z.value = d.getBoundingClientRect().width);
    }, ge = F(() => (d) => _(p.value(d), q.value(d))), Je = F(
      () => E.value.multiCalendars > 0 && t.range ? [...Array(E.value.multiCalendars).keys()] : [0]
    ), Ye = F(
      () => (d) => d === 1
    ), Tt = F(() => t.monthPicker || t.timePicker || t.yearPicker), Ht = F(
      () => ({
        dp__flex_display: E.value.multiCalendars > 0
      })
    ), Wt = F(() => ({
      dp__instance_calendar: E.value.multiCalendars > 0
    })), zt = F(() => ({
      dp__menu_disabled: t.disabled,
      dp__menu_readonly: t.readonly
    })), At = F(
      () => (d) => xt(ge, d)
    ), ht = F(
      () => ({
        dp__menu: !0,
        dp__menu_index: !t.inline,
        dp__relative: t.inline,
        [t.menuClassName]: !!t.menuClassName
      })
    ), xt = (d, V) => d.value(V).map((we) => ({
      ...we,
      days: we.days.map((be) => (be.marker = m(be), be.classData = Ne(be), be))
    })), Kt = (d) => {
      d.stopPropagation(), d.stopImmediatePropagation();
    }, jt = () => {
      t.escClose && a("close-picker");
    }, St = (d, V = !1) => {
      o(d, V), t.spaceConfirm && a("select-date");
    }, Ct = (d) => {
      var V;
      (V = t.flow) != null && V.length && (A[d] = !0, Object.keys(A).filter((we) => !A[we]).length || Gt());
    }, ct = (d, V, we, be, ...Ke) => {
      if (t.flow[w.value] === d) {
        const X = be ? V.value[0] : V.value;
        X && X[we](...Ke);
      }
    }, Gt = () => {
      ct("month", c, "toggleMonthPicker", !0, !0), ct("year", c, "toggleYearPicker", !0, !0), ct("calendar", te, "toggleTimePicker", !1, !1, !0), ct("time", te, "toggleTimePicker", !1, !0, !0);
      const d = t.flow[w.value];
      (d === "hours" || d === "minutes" || d === "seconds") && ct(d, te, "toggleTimePicker", !1, !0, !0, d);
    }, i = (d) => {
      if (t.arrowNavigation) {
        if (d === "up")
          return le();
        if (d === "down")
          return x();
        if (d === "left")
          return ee();
        if (d === "right")
          return J();
      } else
        d === "left" || d === "up" ? Y("left", 0, d === "up") : Y("right", 0, d === "down");
    }, D = (d) => {
      f(d.shiftKey), !t.disableMonthYearSelect && d.code === "Tab" && d.target.classList.contains("dp__menu") && y.value.shiftKeyInMenu && (d.preventDefault(), d.stopImmediatePropagation(), a("close-picker"));
    }, Q = (d) => {
      c.value[0] && c.value[0].handleMonthYearChange(d);
    };
    return n({
      updateMonthYear: l
    }), (d, V) => {
      var we;
      return h(), fe(gt, {
        appear: "",
        name: (we = u(E).transitions) == null ? void 0 : we.menuAppear,
        mode: "out-in",
        css: !!d.transitions
      }, {
        default: oe(() => {
          var be, Ke;
          return [
            ae("div", {
              id: d.uid ? `dp-menu-${d.uid}` : void 0,
              tabindex: "0",
              ref_key: "dpMenuRef",
              ref: H,
              role: "dialog",
              class: ye(u(ht)),
              onMouseleave: V[15] || (V[15] = //@ts-ignore
              (...X) => u(se) && u(se)(...X)),
              onClick: Kt,
              onKeydown: [
                ue(jt, ["esc"]),
                V[16] || (V[16] = ue(Ze((X) => i("left"), ["prevent"]), ["left"])),
                V[17] || (V[17] = ue(Ze((X) => i("up"), ["prevent"]), ["up"])),
                V[18] || (V[18] = ue(Ze((X) => i("down"), ["prevent"]), ["down"])),
                V[19] || (V[19] = ue(Ze((X) => i("right"), ["prevent"]), ["right"])),
                D
              ]
            }, [
              (d.disabled || d.readonly) && d.inline ? (h(), O("div", {
                key: 0,
                class: ye(u(zt))
              }, null, 2)) : S("", !0),
              !d.inline && !d.teleportCenter ? (h(), O("div", {
                key: 1,
                class: ye(u(Re))
              }, null, 2)) : S("", !0),
              ae("div", {
                class: ye({
                  dp__menu_content_wrapper: ((be = d.presetRanges) == null ? void 0 : be.length) || !!d.$slots["left-sidebar"] || !!d.$slots["right-sidebar"]
                })
              }, [
                d.$slots["left-sidebar"] ? (h(), O("div", qr, [
                  K(d.$slots, "left-sidebar", Pe(Le({ handleMonthYearChange: Q })))
                ])) : S("", !0),
                (Ke = d.presetRanges) != null && Ke.length ? (h(), O("div", Jr, [
                  (h(!0), O(ce, null, De(d.presetRanges, (X, ft) => (h(), O("div", {
                    key: ft,
                    style: Qe(X.style || {}),
                    class: "dp__preset_range",
                    onClick: (ie) => u(v)(X.range, !!X.slot)
                  }, [
                    X.slot ? K(d.$slots, X.slot, {
                      key: 0,
                      presetDateRange: u(v),
                      label: X.label,
                      range: X.range
                    }) : (h(), O(ce, { key: 1 }, [
                      ze(Ce(X.label), 1)
                    ], 64))
                  ], 12, Qr))), 128))
                ])) : S("", !0),
                ae("div", {
                  class: "dp__instance_calendar",
                  ref_key: "calendarWrapperRef",
                  ref: U,
                  role: "document"
                }, [
                  ae("div", {
                    class: ye(u(Ht))
                  }, [
                    (h(!0), O(ce, null, De(u(Je), (X, ft) => (h(), O("div", {
                      key: X,
                      class: ye(u(Wt))
                    }, [
                      !d.disableMonthYearSelect && !d.timePicker ? (h(), fe(Yr, Te({
                        key: 0,
                        ref_for: !0,
                        ref: (ie) => {
                          ie && (c.value[ft] = ie);
                        },
                        months: u(ne),
                        years: u(rt),
                        month: u(p)(X),
                        year: u(q)(X),
                        instance: X,
                        "internal-model-value": e.internalModelValue
                      }, d.$props, {
                        onMount: V[0] || (V[0] = (ie) => Ct("monthYearInput")),
                        onResetFlow: G,
                        onUpdateMonthYear: (ie) => u(l)(X, ie),
                        onMonthYearSelect: u(r),
                        onOverlayClosed: C
                      }), Ve({ _: 2 }, [
                        De(u(xe), (ie, qn) => ({
                          name: ie,
                          fn: oe((Zt) => [
                            K(d.$slots, ie, Pe(Le(Zt)))
                          ])
                        }))
                      ]), 1040, ["months", "years", "month", "year", "instance", "internal-model-value", "onUpdateMonthYear", "onMonthYearSelect"])) : S("", !0),
                      et($r, Te({
                        ref_for: !0,
                        ref: (ie) => {
                          ie && (M.value[ft] = ie);
                        },
                        "specific-mode": u(Tt),
                        "get-week-num": u(g),
                        instance: X,
                        "mapped-dates": u(At)(X),
                        month: u(p)(X),
                        year: u(q)(X)
                      }, d.$props, {
                        "flow-step": w.value,
                        "onUpdate:flowStep": V[1] || (V[1] = (ie) => w.value = ie),
                        onSelectDate: (ie) => u(o)(ie, !u(Ye)(X)),
                        onHandleSpace: (ie) => St(ie, !u(Ye)(X)),
                        onSetHoverDate: V[2] || (V[2] = (ie) => u(W)(ie)),
                        onHandleScroll: (ie) => u(k)(ie, X),
                        onHandleSwipe: (ie) => u(R)(ie, X),
                        onMount: V[3] || (V[3] = (ie) => Ct("calendar")),
                        onResetFlow: G,
                        onTooltipOpen: V[4] || (V[4] = (ie) => d.$emit("tooltip-open", ie)),
                        onTooltipClose: V[5] || (V[5] = (ie) => d.$emit("tooltip-close", ie))
                      }), Ve({ _: 2 }, [
                        De(u(Xe), (ie, qn) => ({
                          name: ie,
                          fn: oe((Zt) => [
                            K(d.$slots, ie, Pe(Le({ ...Zt })))
                          ])
                        }))
                      ]), 1040, ["specific-mode", "get-week-num", "instance", "mapped-dates", "month", "year", "flow-step", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
                    ], 2))), 128))
                  ], 2),
                  ae("div", null, [
                    d.$slots["time-picker"] ? K(d.$slots, "time-picker", Pe(Te({ key: 0 }, { time: u(j), updateTime: u(I) }))) : (h(), O(ce, { key: 1 }, [
                      d.enableTimePicker && !d.monthPicker && !d.weekPicker ? (h(), fe(Gr, Te({
                        key: 0,
                        ref_key: "timePickerRef",
                        ref: te,
                        hours: u(j).hours,
                        minutes: u(j).minutes,
                        seconds: u(j).seconds,
                        "internal-model-value": e.internalModelValue
                      }, d.$props, {
                        onMount: V[6] || (V[6] = (X) => Ct("timePicker")),
                        "onUpdate:hours": V[7] || (V[7] = (X) => u(I)(X)),
                        "onUpdate:minutes": V[8] || (V[8] = (X) => u(I)(X, !1)),
                        "onUpdate:seconds": V[9] || (V[9] = (X) => u(I)(X, !1, !0)),
                        onResetFlow: G,
                        onOverlayClosed: C,
                        onOverlayOpened: V[10] || (V[10] = (X) => d.$emit("time-picker-open", X))
                      }), Ve({ _: 2 }, [
                        De(u(qe), (X, ft) => ({
                          name: X,
                          fn: oe((ie) => [
                            K(d.$slots, X, Pe(Le(ie)))
                          ])
                        }))
                      ]), 1040, ["hours", "minutes", "seconds", "internal-model-value"])) : S("", !0)
                    ], 64))
                  ])
                ], 512),
                d.$slots["right-sidebar"] ? (h(), O("div", el, [
                  K(d.$slots, "right-sidebar", Pe(Le({ handleMonthYearChange: Q })))
                ])) : S("", !0),
                d.showNowButton ? (h(), O("div", tl, [
                  d.$slots["now-button"] ? K(d.$slots, "now-button", {
                    key: 0,
                    selectCurrentDate: u(b)
                  }) : S("", !0),
                  d.$slots["now-button"] ? S("", !0) : (h(), O("button", {
                    key: 1,
                    type: "button",
                    role: "button",
                    class: "dp__now_button",
                    onClick: V[11] || (V[11] = //@ts-ignore
                    (...X) => u(b) && u(b)(...X))
                  }, Ce(d.nowButtonLabel), 1))
                ])) : S("", !0)
              ], 2),
              !d.autoApply || d.keepActionRow ? (h(), fe(mr, Te({
                key: 2,
                "menu-mount": B.value,
                "calendar-width": z.value,
                "internal-model-value": e.internalModelValue
              }, d.$props, {
                onClosePicker: V[12] || (V[12] = (X) => d.$emit("close-picker")),
                onSelectDate: V[13] || (V[13] = (X) => d.$emit("select-date")),
                onInvalidSelect: V[14] || (V[14] = (X) => d.$emit("invalid-select"))
              }), Ve({ _: 2 }, [
                De(u(re), (X, ft) => ({
                  name: X,
                  fn: oe((ie) => [
                    K(d.$slots, X, Pe(Le({ ...ie })))
                  ])
                }))
              ]), 1040, ["menu-mount", "calendar-width", "internal-model-value"])) : S("", !0)
            ], 42, Xr)
          ];
        }),
        _: 3
      }, 8, ["name", "css"]);
    };
  }
}), al = typeof window < "u" ? window : void 0, ln = () => {
}, rl = (e) => Qn() ? (ea(e), !0) : !1, ll = (e, n, a, t) => {
  if (!e)
    return ln;
  let s = ln;
  const f = tt(
    () => u(e),
    (_) => {
      s(), _ && (_.addEventListener(n, a, t), s = () => {
        _.removeEventListener(n, a, t), s = ln;
      });
    },
    { immediate: !0, flush: "post" }
  ), y = () => {
    f(), s();
  };
  return rl(y), y;
}, ol = (e, n, a, t = {}) => {
  const { window: s = al, event: f = "pointerdown" } = t;
  return s ? ll(s, f, (_) => {
    const E = $e(e), T = $e(n);
    !E || !T || E === _.target || _.composedPath().includes(E) || _.composedPath().includes(T) || a(_);
  }, { passive: !0 }) : void 0;
}, sl = /* @__PURE__ */ We({
  __name: "VueDatePicker",
  props: {
    ...at
  },
  emits: [
    "update:model-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open"
  ],
  setup(e, { expose: n, emit: a }) {
    const t = e, s = cn(), f = L(!1), y = $t(t, "modelValue"), _ = $t(t, "timezone"), E = L(null), T = L(null), U = L(!1), A = L(null), { setMenuFocused: c, setShiftKey: M } = Kn(), { clearArrowNav: te } = nt(), { validateDate: H, isValidTime: z } = Ee(t);
    He(() => {
      G(t.modelValue), t.inline || (de(A.value).addEventListener("scroll", l), window.addEventListener("resize", o)), t.inline && (f.value = !0);
    }), dn(() => {
      if (!t.inline) {
        const ne = de(A.value);
        ne && ne.removeEventListener("scroll", l), window.removeEventListener("resize", o);
      }
    });
    const B = it(s, "all", t.presetRanges), w = it(s, "input");
    tt(
      [y, _],
      () => {
        G(y.value);
      },
      { deep: !0 }
    );
    const { openOnTop: J, menuPosition: ee, setMenuPosition: x, setInitialPosition: le, getScrollableParent: de } = nr(
      E,
      T,
      a,
      t
    ), {
      inputValue: C,
      internalModelValue: N,
      parseExternalModelValue: G,
      emitModelValue: P,
      formatInputValue: Z,
      checkBeforeEmit: p
    } = er(a, t, U), q = F(
      () => ({
        dp__main: !0,
        dp__theme_dark: t.dark,
        dp__theme_light: !t.dark,
        dp__flex_display: t.inline,
        dp__flex_display_with_input: t.inlineWithInput
      })
    ), j = F(() => t.dark ? "dp__theme_dark" : "dp__theme_light"), I = F(() => t.teleport ? {
      to: typeof t.teleport == "boolean" ? "body" : t.teleport,
      disabled: t.inline
    } : { class: "dp__outer_menu_wrap" }), l = () => {
      f.value && (t.closeOnScroll ? W() : x());
    }, o = () => {
      f.value && x();
    }, g = () => {
      !t.disabled && !t.readonly && (le(), f.value = !0, dt().then(() => {
        x(), f.value && a("open");
      }), f.value || v(), G(t.modelValue));
    }, r = () => {
      C.value = "", v(), a("update:model-value", null), a("cleared"), W();
    }, k = () => {
      const ne = N.value;
      return !ne || !Array.isArray(ne) && H(ne) ? !0 : Array.isArray(ne) ? ne.length === 2 && H(ne[0]) && H(ne[1]) ? !0 : H(ne[0]) : !1;
    }, Y = () => {
      p() && k() ? (P(), W()) : a("invalid-select", N.value);
    }, R = (ne) => {
      m(), P(), t.closeOnAutoApply && !ne && W();
    }, m = () => {
      T.value && t.textInput && T.value.setParsedDate(N.value);
    }, b = (ne = !1) => {
      t.autoApply && z(N.value) && k() && (t.range && Array.isArray(N.value) ? (t.partialRange || N.value.length === 2) && R(ne) : R(ne));
    }, v = () => {
      t.textInput || (N.value = null);
    }, W = () => {
      t.inline || (f.value && (f.value = !1, c(!1), M(!1), te(), a("closed"), le(), C.value && G(y.value)), v());
    }, se = (ne, me) => {
      if (!ne) {
        N.value = null;
        return;
      }
      N.value = ne, me && (Y(), a("text-submit"));
    }, Ne = () => {
      t.autoApply && z(N.value) && P(), m();
    }, Xe = () => f.value ? W() : g(), re = (ne) => {
      N.value = ne;
    }, qe = () => {
      t.textInput && (U.value = !0, Z()), a("focus");
    }, xe = () => {
      t.textInput && (U.value = !1, G(t.modelValue)), a("blur");
    }, Re = (ne) => {
      E.value && E.value.updateMonthYear(0, {
        month: Nn(ne.month),
        year: Nn(ne.year)
      });
    }, rt = (ne) => {
      G(ne || t.modelValue);
    };
    return ol(
      E,
      T,
      t.onClickOutside ? () => t.onClickOutside(k) : W
    ), n({
      closeMenu: W,
      selectDate: Y,
      clearValue: r,
      openMenu: g,
      onScroll: l,
      formatInputValue: Z,
      // exposed for testing purposes
      updateInternalModelValue: re,
      // modify internal modelValue
      setMonthYear: Re,
      parseModel: rt
    }), (ne, me) => (h(), O("div", {
      class: ye(u(q)),
      ref_key: "pickerWrapperRef",
      ref: A
    }, [
      et(dr, Te({
        ref_key: "inputRef",
        ref: T,
        "is-menu-open": f.value,
        "input-value": u(C),
        "onUpdate:inputValue": me[0] || (me[0] = (ge) => ot(C) ? C.value = ge : null)
      }, ne.$props, {
        onClear: r,
        onOpen: g,
        onSetInputDate: se,
        onSetEmptyDate: u(P),
        onSelectDate: Y,
        onToggle: Xe,
        onClose: W,
        onFocus: qe,
        onBlur: xe
      }), Ve({ _: 2 }, [
        De(u(w), (ge, Je) => ({
          name: ge,
          fn: oe((Ye) => [
            K(ne.$slots, ge, Pe(Le(Ye)))
          ])
        }))
      ]), 1040, ["is-menu-open", "input-value", "onSetEmptyDate"]),
      f.value ? (h(), fe(Yn(ne.teleport ? ta : "div"), Pe(Te({ key: 0 }, u(I))), {
        default: oe(() => [
          f.value ? (h(), fe(nl, Te({
            key: 0,
            ref_key: "dpMenuRef",
            ref: E,
            class: u(j),
            style: u(ee),
            "open-on-top": u(J)
          }, ne.$props, {
            "internal-model-value": u(N),
            "onUpdate:internalModelValue": me[1] || (me[1] = (ge) => ot(N) ? N.value = ge : null),
            onClosePicker: W,
            onSelectDate: Y,
            onAutoApply: b,
            onTimeUpdate: Ne,
            onFlowStep: me[2] || (me[2] = (ge) => ne.$emit("flow-step", ge)),
            onUpdateMonthYear: me[3] || (me[3] = (ge) => ne.$emit("update-month-year", ge)),
            onInvalidSelect: me[4] || (me[4] = (ge) => ne.$emit("invalid-select", u(N))),
            onInvalidFixedRange: me[5] || (me[5] = (ge) => ne.$emit("invalid-fixed-range", ge)),
            onRecalculatePosition: u(x),
            onTooltipOpen: me[6] || (me[6] = (ge) => ne.$emit("tooltip-open", ge)),
            onTooltipClose: me[7] || (me[7] = (ge) => ne.$emit("tooltip-close", ge)),
            onTimePickerOpen: me[8] || (me[8] = (ge) => ne.$emit("time-picker-open", ge))
          }), Ve({ _: 2 }, [
            De(u(B), (ge, Je) => ({
              name: ge,
              fn: oe((Ye) => [
                K(ne.$slots, ge, Pe(Le({ ...Ye })))
              ])
            }))
          ]), 1040, ["class", "style", "open-on-top", "internal-model-value", "onRecalculatePosition"])) : S("", !0)
        ]),
        _: 3
      }, 16)) : S("", !0)
    ], 2));
  }
}), Xn = /* @__PURE__ */ (() => {
  const e = sl;
  return e.install = (n) => {
    n.component("Vue3DatePicker", e);
  }, e;
})(), il = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xn
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(il).forEach(([e, n]) => {
  e !== "default" && (Xn[e] = n);
});
export {
  Xn as default
};
